import React, { useState, useEffect, useContext } from 'react';
import { api } from '../api';
import { fetchToken, fetchRole } from '../auth/Token';
import { 
  Box, 
  Button, 
  IconButton, 
  Typography, 
  TextField, 
  Avatar, 
  CircularProgress, 
  Switch, 
  Grid, 
  Fab, 
  Chip, 
  Accordion, 
  AccordionSummary,
  AccordionDetails,
  Backdrop,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListSubheader,
  ListItemAvatar,
  ListItemButton,
  Divider,
  Alert,
  Modal,
  Autocomplete,
  Tooltip,
  Slider,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
  RemoveCircleIcon,
  Card,
  CardHeader,
  CardContent,
  CardActions
 } from "@mui/material";
import { DataGrid, GridToolbar, GridRowParams, GridActionsCellItem} from '@mui/x-data-grid';
import RecommendIcon from '@mui/icons-material/Recommend';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import Snackbar from '@mui/material/Snackbar';
import AuthContext from "../auth/AuthProvider";
import CloseIcon from '@mui/icons-material/Close';
import { useNavigate } from 'react-router-dom';
import MoreIcon from '@mui/icons-material/More';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import { Page, Text, View, Document, StyleSheet, Image } from '@react-pdf/renderer';
import DialogTitle from '@mui/material/DialogTitle';
import { PDFViewer, Font,PDFDownloadLink } from "@react-pdf/renderer";
import SendIcon from '@mui/icons-material/Send';
import Slide from '@mui/material/Slide';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import KPeeLogo from '../LogoKPee1.png';
import SoyaLogo from '../soyalogo.png';
import { decode } from "base-64";
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import CancelIcon from '@mui/icons-material/Cancel';
import LoanAdviseCommodity from './LoanAdviseCommodity';
import { Refresh, Send, OpenInNew } from "@mui/icons-material";
import { Cancel, ExpandMore } from "@mui/icons-material";
import { styled } from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import moment, { now } from 'moment';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';
import './../working.css';
import { toast } from 'sonner'
import StickyNote2RoundedIcon from '@mui/icons-material/StickyNote2Rounded';


const currencyFormat = new Intl.NumberFormat('en-GH', {
  style: 'currency',
  currency: 'GHS',
});


const FormatedDate = ({value}) => {
  const timestamp = value;
  const date = new Date(timestamp);

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours() % 12 || 12).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const amOrPm = date.getHours() >= 12 ? 'PM' : 'AM';

  const formattedDate = `${year}-${month}-${day} ${hours}:${minutes} ${amOrPm}`;
  return <span>{formattedDate}</span>;
}

const FormatedDateWithTime = ({value}) => {
  const timestamp = value;
  const date = new Date(timestamp);

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours() % 12 || 12).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const amOrPm = date.getHours() >= 12 ? 'PM' : 'AM';

  const formattedDate = `${year}-${month}-${day} ${hours}:${minutes} ${amOrPm}`;
  return <Text>{formattedDate}</Text>;
}

const FormatedDateNoTime = ({value}) => {
  const timestamp = value;
  const date = new Date(timestamp);

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');

  const formattedDate = `${year}-${month}-${day}`;
  return <Text>{formattedDate}</Text>;
}

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const LoanAdvise = (props) => {
  const [open, setOpen] = React.useState(true);

  const handleclose = () => {
    setOpen(false);
  };
  // console.log(props.More_Details, props.Loan_Details)


  const styles = StyleSheet.create({
    body: {
      margin: 0,
      paddingLeft: 45,
      paddingRight: 45,
      paddingTop: 10,
    },
    header: {
      fontSize: 10,
      marginBottom: 20,
      textAlign: 'center',
      color: 'grey',
    },
    section: {
      flexDirection: 'row',
      padding: 0,
      marginBottom: 20,
      
    },
    sectionn: {
      flexDirection: 'row',
      padding: 0,
      marginBottom: 20,
    },
    sec1: {
      flex: 1,
      margin: 5,
      paddingLeft: 0,
      paddingRight: 50,
      fontSize: 10,
    },
    logo: {
      flex: 1,
      maxWidth: 60,
      height: 50,
      paddingLeft: 0,
      border: '1px outset brown',
      marginRight: 180,
      marginBottom: 5,
    },
    sec2: {
      flex: 1,
      margin: 5,
      marginLeft: 90,
      paddingRight: 0,
      textAlign: 'justify',
      fontSize: 10,
      color: '#805b10',
    },
    sec21: {
      flex: 1,
      margin: 5,
      marginLeft: 90,
      paddingRight: 0,
      textAlign: 'justify',
      fontSize: 10,
    },
    title: {
      textAlign: 'center',
      textDecoration: 'underline',
    },
    salutation: {
      fontSize: 10,
      marginBottom: 10,
      marginTop: 10,
      textAlign: 'left',
    },
    message: {
      fontSize: 10,
      fontWeight: 'bold',
      textAlign: 'justify',
    },
    end: {
      color: 'brown',
      fontSize: 10,
      fontWeight: 'bold',
      textAlign: 'left',
      marginTop: 6,
    },
    important: {
      fontFamily: 'Roboto',
      fontWeight: 900,
      fontSize: 10,
    },
    sec1color: {
      color: '#064F80',
    },
    table: {
      display: 'table',
      width: 'auto',
      borderStyle: 'solid',
      borderWidth: 1,
      borderRightWidth: 0,
      borderBottomWidth: 0,
      marginTop: 5,
      marginBottom: 20,
      borderRadius: 2,
      color: 'gray',
    },
    tableRow: {
      margin: 'auto',
      flexDirection: 'row',
      color: 'black',
    },
    tableCol: {
      width: '50%',
      borderStyle: 'solid',
      borderWidth: 1,
      borderLeftWidth: 0,
      borderTopWidth: 0,
    },
    tableCol1: {
      width: '25%',
      borderStyle: 'solid',
      borderWidth: 1,
      borderLeftWidth: 0,
      borderTopWidth: 0,
    },
    tableCell: {
      margin: 'auto',
      marginTop: 5,
      fontSize: 10,
      textAlign: 'left',
      paddingBottom: 2,
      color: 'black',
    },
    tableCelll: {
      fontSize: 10,
      padding: 5,
      color: 'black',
    },
    charge: {
      color: 'brown',
      fontSize: 9,
      fontWeight: '200',
      textAlign: 'left',
      marginTop: 10,
    },
    repaymentS: {
      fontSize: 12,
    },
    bold: {
      fontWeight: 'semibold',
      fontWeight: '200',
      color: '#14213d',
    },
    pageNumber: {
      position: 'absolute',
      fontSize: 12,
      bottom: 30,
      left: 0,
      right: 0,
      textAlign: 'center',
      color: 'grey',
    },
  });

  const MyLoanAdvise = () => (
    <Document>
    <Page size="A4" style={styles.body}>
      <Text style={styles.header} fixed>
        ~ The Cooperative ~
      </Text>
      <View style={styles.section}>
      	<Image src={KPeeLogo} alt='KPee logo' style={styles.logo} />
        {/* {
          props.More_Details?.community_name?
                  <Text style={styles.sec2}>
                    SOCIETY: <Text style={styles.bold}>{props.More_Details?.society}</Text>{'\n'}
                    CLUSTER: <Text style={styles.bold}>{props.More_Details?.cluster_name}</Text>{'\n'}
                    COMMUNITY: <Text style={styles.bold}>{props.More_Details?.community_name}</Text>{'\n'}
                    SAVINGS GROUP: <Text style={styles.bold}>{props.More_Details.association_name}</Text>{'\n'}
                    WAREHOUSE: <Text style={styles.bold}>{props.More_Details?.warehouse}</Text>{'\n'}
                    PASSBOOK NO.: <Text style={styles.bold}>{props.More_Details?.passbook_id}</Text>{'\n'}
                    Issue Date: <Text style={styles.bold}>{<FormatedDateNoTime value={props.Loan_Details.issue_date} />}</Text>{'\n'}
                  </Text>
                  :
                  <Text style={styles.sec2}>
                    SAVINGS GROUP: <Text style={styles.bold}>{props.More_Details.association_name}</Text>{'\n'}
                    WAREHOUSE: <Text style={styles.bold}>{props.More_Details?.warehouse}</Text>{'\n'}
                    PASSBOOK NO.: <Text style={styles.bold}>{props.More_Details.passbook_id}</Text>{'\n'}
                    Issue Date: <Text style={styles.bold}>{<FormatedDateNoTime value={props.Loan_Details.issue_date} />}</Text>{'\n'}
                  </Text>
              } */}
      </View>
        <Text style={styles.salutation}>
          {
            props.More_Details?.society === "Edjura Society" ||
            props.More_Details?.society === "Mampong"
            ? 'Maize Cooperative' : 'Soya Cooperative'
          }
        </Text>

      <View style={styles.section}>
      	<Text style={styles.sec1}>
          <Text style={styles.sec1color}>From:</Text>{'\n'}
            {props.More_Details?.society}{'\n'}
          </Text>

      	<Text style={styles.sec21}>

        <Text style={styles.sec1color}>To:</Text>{'\n'}
        {`${props.More_Details.firstname} ${props.More_Details?.middlename} ${props.More_Details.lastname}`}{'\n'}
        {props.More_Details.address}{'\n'}
        SAVINGS GROUP: <Text style={styles.bold}>{props.More_Details.association_name}</Text>{'\n'}
                    WAREHOUSE: <Text style={styles.bold}>{props.More_Details?.warehouse}</Text>{'\n'}
                    PASSBOOK NO.: <Text style={styles.bold}>{props.More_Details.passbook_id}</Text>{'\n'}
                    Issue Date: <Text style={styles.bold}>{<FormatedDateNoTime value={props.Loan_Details.issue_date} />}</Text>{'\n'}
        Next of Kin: {props.More_Details.nextOfKin}
        </Text>
      </View>
      <Text style={styles.title}>Loan Advise Letter</Text>
      <Text style={styles.salutation}>Dear Mrs/Mr. {`${props.More_Details.firstname} ${props.More_Details.lastname}`}, </Text>
 
      <Text style={styles.message}>
        We have approved your request for {props.More_Details.account_name} loan of <Text style={styles.important}>GHS{props.Transaction_Details.recommended_amount? props.Transaction_Details.recommended_amount.toFixed(2): props.Transaction_Details.amount.toFixed(2)}</Text>. 
        Which an amount of <Text style={styles.important}>GHS{props.Transaction_Details.amount.toFixed(2)}</Text> was initially requested.
        This loan has been approved for a period of <Text style={styles.important}>{props.Loan_Details.period}</Text> with an interest rate 
        of <Text style={styles.important}>{props.Loan_Details.interest_rate_percentage.toFixed(2)}%</Text>, amounting to <Text style={styles.important}>GHS {props.Loan_Details.interest_rate_amount.toFixed(2)}</Text>. 
        Your repayment schedule will commence on  <Text style={styles.important}>{<FormatedDateNoTime value={props.Loan_Details.repayment_starting_date} />} </Text> 
         and conclude on <Text style={styles.important}>{<FormatedDateNoTime value={props.Loan_Details.repayment_ending_date} />}</Text>.
      </Text>
      <Text style={styles.charge}>
        Charges are automatically deducted from Cooperative savings account
      </Text>

      <View style={styles.table}> 
        <View style={styles.tableRow}> 
          <View style={styles.tableCol}> 
            <Text style={styles.tableCell}>Charges</Text> 
          </View> 
          <View style={styles.tableCol}> 
            <Text style={styles.tableCell}>Amount</Text> 
          </View>
        </View>
        <View style={styles.tableRow}> 
          <View style={styles.tableCol}> 
            <Text style={styles.tableCelll}>Loan Application Fee ({props.More_Details.application_fee.toFixed(2)}%)</Text> 
          </View> 
          <View style={styles.tableCol}> 
            <Text style={styles.tableCelll}>GHS {props.Loan_Details.application_fee.toFixed(2)}</Text> 
          </View> 
        </View>
        <View style={styles.tableRow}> 
          <View style={styles.tableCol}> 
            <Text style={styles.tableCelll}>Loan Processing Fee ({props.More_Details.proccessing_fee.toFixed(2)}%)</Text> 
          </View> 
          <View style={styles.tableCol}> 
            <Text style={styles.tableCelll}>GHS {props.Loan_Details.proccessing_fee.toFixed(2)} </Text> 
          </View> 
        </View>
        <View style={styles.tableRow}> 
          <View style={styles.tableCol}> 
            <Text style={styles.tableCelll}>Total</Text> 
          </View> 
          <View style={styles.tableCol}> 
            <Text style={styles.tableCelll}>{`GHS ${(props.Loan_Details.application_fee + props.Loan_Details.proccessing_fee).toFixed(2)}`} </Text> 
          </View> 
        </View>
      </View>

      <Text style={styles.repaymentS}>
		    Repayment Schedule {props.More_Details.time === "weeks"? " (Weekly Payments)" : " (Monthly Payments)"}
      </Text>

      <View style={styles.table}> 
        <View style={styles.tableRow}> 
          <View style={styles.tableCol1}>  
            <Text style={styles.tableCell}>Repayment Date</Text> 
          </View> 
          <View style={styles.tableCol1}> 
            <Text style={styles.tableCell}>Principal Amount</Text> 
          </View>
          <View style={styles.tableCol1}> 
            <Text style={styles.tableCell}>Interest Amount</Text> 
          </View>
          <View style={styles.tableCol1}> 
            <Text style={styles.tableCell}>Total Repayment</Text> 
          </View>
        </View>
        {
          props.Repayment_Schedule.map((item) => (
            <View style={styles.tableRow}> 
              <View style={styles.tableCol1}> 
                <Text style={styles.tableCelll}>{item.Date}</Text> 
              </View> 
              <View style={styles.tableCol1}> 
                <Text style={styles.tableCelll}>{item.Amount_to_be_Paid.toFixed(2)}</Text> 
              </View>
              <View style={styles.tableCol1}> 
                <Text style={styles.tableCelll}>{item.Interest_Amount.toFixed(2)}</Text> 
              </View>
              <View style={styles.tableCol1}> 
                <Text style={styles.tableCelll}>{(item.Amount_to_be_Paid + item.Interest_Amount).toFixed(2)}</Text> 
              </View>
            </View>
          ))
        }
            <View style={styles.tableRow}> 
              <View style={styles.tableCol1}> 
                <Text style={styles.tableCelll}><Text style={styles.important}>Total GHS</Text></Text> 
              </View>import { toast } from 'sonner';


              <View style={styles.tableCol1}> 
                <Text style={styles.tableCelll}>{props.Amount_Total.toFixed(2)}</Text> 
              </View>
              <View style={styles.tableCol1}> 
                <Text style={styles.tableCelll}>{props.Interest_Total.toFixed(2)}</Text> 
              </View>
              <View style={styles.tableCol1}> 
                <Text style={styles.tableCelll}>{props.Total_Khraa.toFixed(2)}</Text> 
              </View>
            </View>
        
        
      </View>
      
      <Text style={styles.end}>
        Report any issue regarding the loan to our office or call: 0244815594.
      </Text>
    </Page>
  </Document>
  );
  Font.register({
    family: 'Roboto',
    src: 'https://cdn.jsdelivr.net/npm/open-sans-all@0.1.3/fonts/open-sans-800.ttf',
    fontWeight: 800,
  });

  return(
    <>
    <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleclose}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>{"Loan Advise"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            Loan Advise Generated Successfully.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleclose} variant='contained' color='success' sx={{ marginRight:1 }}>Close</Button>
          {/* <Button onClick={handleView}>View</Button> */}
          <PDFDownloadLink document={<MyLoanAdvise />} filename="FORM">
              {({loading}) => (loading ?  <Button variant='contained' color='success'>Loading...</Button> :  <Button variant='contained' color='success'>Download</Button> )}
          </PDFDownloadLink>
          
         
        </DialogActions>
      </Dialog>
    </>
  )
};

const Iteme = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  // textAlign: 'center',
  color: theme.palette.text.secondary,
}));

const PrettoSlider = styled(Slider)({
  color: '#52af77',
  height: 8,
  '& .MuiSlider-track': {
    border: 'none',
  },
  '& .MuiSlider-thumb': {
    height: 24,
    width: 24,
    backgroundColor: '#fff',
    border: '2px solid currentColor',
    '&:focus, &:hover, &.Mui-active, &.Mui-focusVisible': {
      boxShadow: 'inherit',
    },
    '&::before': {
      display: 'none',
    },
  },
  '& .MuiSlider-valueLabel': {
    lineHeight: 1.2,
    fontSize: 12,
    background: 'unset',
    padding: 0,
    width: 32,
    height: 32,
    borderRadius: '50% 50% 50% 0',
    backgroundColor: '#52af77',
    transformOrigin: 'bottom left',
    transform: 'translate(50%, -100%) rotate(-45deg) scale(0)',
    '&::before': { display: 'none' },
    '&.MuiSlider-valueLabelOpen': {
      transform: 'translate(50%, -100%) rotate(-45deg) scale(1)',
    },
    '& > *': {
      transform: 'rotate(45deg)',
    },
  },
});

const ItemCard = styled(Paper)(({ theme }) => ({
  backgroundColor: '#52b788',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  margin: '10px' 
}));

const ItemCardI = styled(Paper)(({ theme }) => ({
  backgroundColor: '#b7e4c7',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  margin: '10px' 
}));

const ItemCardSS = styled(Paper)(({ theme }) => ({
  backgroundColor: '#52b788',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  margin: '5px' 
}));

const ItemCardSI = styled(Paper)(({ theme }) => ({
  backgroundColor: '#b7e4c7',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  margin: '5px' 
}));

const GroupName = ({
  handleConfirmBuild,
  typ
}) => {
  const [open, setOpen] = useState(true);
  const [name, setName] = useState('');


  const handleClose = () => {
    setOpen(false);
  };

  const handleConfirmGroup = () => {
    handleClose();
    handleConfirmBuild(name, typ);
  };
  
  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 620,
    maxHeight: '80vh',
    overflowY: 'auto', 
    '&::-webkit-scrollbar': {
        width: '7px',
    },
    '&::-webkit-scrollbar-track': {
        background: '#f1f1f1',
    },
    '&::-webkit-scrollbar-thumb': {
        background: '#888',
        borderRadius: '10px',
    },
    '&::-webkit-scrollbar-thumb:hover': {
        background: '#555',
    },
    bgcolor: 'background.paper',
    border: '1px solid #e7ecef',
    borderRadius: '7px',
    boxShadow: 24,
    p: 4,
  };

  return (
    <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Typography sx={{ textAlign:' center' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
          <b>New group name (optional)</b>
        </Typography>
        <Box>
          <TextField 
            size='small'
            fullWidth
            value={name}
            name='name'
            onChange={(e) => setName(e.target.value)}
          />
        </Box>
        <Button
          size='small'
          variant='contained'
          color='success'
          sx={{ 
            m:1,
            borderRadius:4,
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)'
          }}
          onClick={handleConfirmGroup}
        >
          Build Group
        </Button>
      </Box>
    </Modal>
  )
}

const AssociationDisbursedLoans = (props) => {
  const [approvedLoans, setApprovedLoans] = useState([])
  const [disbusedLoans, setDisbursedLoans] = useState([])
  const [requestedLoans, setRequestedLoans] = useState([])
  const [group_documents, setGroup_documents] = useState([])
  const [info, setInfo] = useState([])
  const [messageid, setMessageid] = useState(null);
  const [open, setOpen] = React.useState(false);
  const [image, setImage] = useState(null)
  const [fileName, setFileName] = useState("No selected file")
  const [upload_open, setUpload_open] = React.useState(false);
  const [opennn, setOpennn] = React.useState();
  const [repayment_starts, setRepayment_starts] = React.useState('');
  const [num_of_weeks_to_end_payment, setNum_of_weeks_to_end_payment] = React.useState(null);
  const [interest_period, setInterest_period] = React.useState(null);
  const navigate = useNavigate(); 
  const {  permissions } = useContext(AuthContext);
  const [start_date, setStart_date] = useState('')
  const [end_date, setEnd_date] = useState('')
  const [start_date_apr, setStart_date_apr] = useState('')
  const [end_date_apr, setEnd_date_apr] = useState('')
  const [start_date_dis, setStart_date_dis] = useState('')
  const [end_date_dis, setEnd_date_dis] = useState('')
  const [reg_amount_sum, setReg_amount_sum] = useState([]);
  const [apr_amount_sum, setApr_amount_sum] = useState([]);
  const [dis_amount_sum, setDis_amount_sum] = useState([]);
  const [society, setSociety] = useState([]);
  const [soc, setSoc] = useState();
  const [accounts, setAccounts] = useState([]);
  const [nm, setNm] = useState("");
  const [typese, setTypes] = useState("");
  const [hold_group_id, setHold_group_id] = useState(null)
  const [transferDetails, setTransferDetails] = useState([]);
  const [openn, setOpenn] = useState(false);
  const [idd, setIdd] = useState();
  const [nowAmount, setNowAmount] = useState();
  const [nowAmountat, setNowAmountat] = useState();
  const [account_idd, setAccount_idd] = useState();
  const [form_group, setForm_group] = useState(false);
  const [group_data, setGroup_data] = useState([]);
  const [groups, setGroups] = useState([]);
  const [groups_cash, setGroups_cash] = useState([]);
  const [form_group_cash, setForm_group_cash] = useState(false);
  const [group_data_cash, setGroup_data_cash] = useState([]);
  const [backdrop_open, setBackdrop_open] = useState(false)
  const [season_details, setSeason_details] = useState()
  const [season_season, setSeason_season] = useState('')
  const [account_details, setAccount_details] = useState()
  const [account_account, setAccount_account] = useState('')
  const [added_trs, setAdded_trs] = useState([]) 
  const [alert, setAlert] = useState(false)
  const [req_modal, setReq_modal] = useState(false)
  const [req_modal_cash, setReq_modal_cash] = useState(false)
  const [hold_member_id, setHold_member_id] = useState(null)
  const [hold_member_psb, setHold_member_psb] = useState(null)
  const [hold_member_acc_id, setHold_member_acc_id] = useState(null)
  const [hold_member_acc_id_cash, setHold_member_acc_id_cash] = useState(null)
  // from SeasonDetails
  const [details, setDetails] = useState([])
  const [deep_details, setDeep_details] = useState();
  const [member_crops, setMember_crops] = useState([])
  const [service_subscribed, setService_subscribed] = useState([]);
  const [input_subscribed, setInput_subscribed] = useState([]);
  const [hold_crop, setHold_crop] = useState('');
  const [hold_crop_id, setHold_crop_id] = useState(null);
  const [hold_acres, setHold_acres] = useState(null);
  const [slider_value, setSlider_value] = useState(1);
  const [subscribed_s, setSubscribed_s] = useState([]);
  const [subscribed_i, setSubscribed_i] = useState([]);
  const [name_modal, setName_modal] = useState();
  const [openImageModal, setOpenImageModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [ecash, setEcash] = useState(false);

  const handleOpenImageModal = (image) => {
    setSelectedImage(image);
    setOpenImageModal(true);
  };

  const handleCloseImageModal = () => {
    setOpenImageModal(false);
    setSelectedImage(null);
  };


   //   Loan Request
   const formiko = useFormik({
    initialValues: {
        transactiontype_id: 2,
        Amount: null,
        narration: '',
        // loans_acc_id: hold_member_acc_id_cash,
        type: 'cash',
        percent: null
    },
    validationSchema: Yup.object({
        Amount: Yup.number()
            .required('Specify Amount to Request')
            .min(info[0]?.Min_amt)
            .max(info[0]?.Max_amt),
        narration: Yup.string()
    }),
    onSubmit: (values) => {
      const data = {
        'transactiontype_id': values.transactiontype_id,
        'Amount': values.Amount,
        'narration': values.narration,
        'loans_acc_id': hold_member_acc_id_cash,
        'type': 'cash',
        'percent': values.percent
    }
        api.post('/transactions/transaction/loans', data , {
            headers: {
                Authorization:'Bearer ' + fetchToken(),
            },
        }).then(function (response) {
            toast.success(response.data, {
              description: 'Click on account to see new updates',
            })
            formiko.handleReset()
            handleProductionGroups();
            closeMakeRequest();
            handleProductionGroupsCash()
        }).catch(function (error){
            console.log(error)
        })
    }
})

const [open_recommend, setOpen_recommend] = useState(false)
const [id_recommend, setId_recommend] = useState(null)
const [id_amount, setId_amount] = useState(null)
const [data_recommend, setData_recommend] = useState({})
const [recco, setRecco] = useState(null)
const [recco_message, setRecco_message] = useState('')

// Recommendations
const recommend = (loan_id, amount, rec_amount, message) => {
  setId_recommend(loan_id)
  setId_amount(amount)
  setRecco(rec_amount)
  setRecco_message(message)
  api.get(`/transactions/recommend/loan/details/${loan_id}`, {
    headers: {
        Authorization:'Bearer ' + fetchToken(),
    },
  }).then(function (response) {
      setData_recommend(response.data);
      setOpen_recommend(true);
  }).catch(function (error){
      console.log(error)
  })
}

const handleRecommend = () => {
  const data = new FormData()
  data.append('transaction_id', id_recommend)
  data.append('rec_amount', recco)
  data.append('rec_message', recco_message)

  api.post('/transactions/recommend/give/one', data, {
    headers: {
        Authorization:'Bearer ' + fetchToken(),
    },
  }).then(function (response) {
      closeRecommend();
      toast.success(response.data, {
        description: 'Click on account to see new updates',
      })
      handleProductionGroupsCash();
  }).catch(function (error){
      console.log(error)
  })
}

const closeRecommend = () => {
  setOpen_recommend(false);
  setRecco(null);
  setRecco_message('')
}



  // from OneMember
  const [farm_crops, setFarm_crops] = useState([]);


  const doNothing = () => {
    return null
  }

  const formik = useFormik({
    initialValues: {
        farmer_language: '',
        land_location: '',
        crops: [],
        member_id: hold_member_id,
  },
  validationSchema: Yup.object({
      "land_size_acres": Yup.number(),
  }),
  onSubmit: (values) => {
    const data = {
        'farmer_language': values.farmer_language,
        'land_location': values.land_location,
        'member_id': hold_member_id,
        'crops': values.crops,
        'lat': 0,
        'long': 0
    }

    toast.promise(
      api.post('/members/farmer/now/save', data ,{
            headers: {
                Authorization: 'Bearer ' + fetchToken()
            }
        }),
        {
          loading: 'Saving...',
          success: (response) => {
            formik.handleReset();
            handleProductionGroups();
            // openMakeRequest(hold_member_psb, hold_member_id, hold_member_acc_id);
            return response.data
          },
          error: (error) => {
            console.log(error)
            return 'An error occurred'
          }
        }
    )
  }
})

  const groupStat = (status, id, types, amount) => {
    const data = new FormData()
    data.append('group_loan_id', id)
    data.append('status', status)
    data.append('types', types)
    // console.log(amount)
    if(types !== "production" && status === "disbursed"){
      setOpen(true);
      setNowAmount(amount);
      setTypes("cash");
      setHold_group_id(id);
      api.post('/association/change/status', data ,{
        headers: {
            Authorization: 'Bearer ' + fetchToken()
        }
      }).then(function (response){
          toast.success(response.data);
          fetch_group_loans();
          AllApprovedLoans()
          AllDisbursedLoans()
          AllRequestedLoans()
      }).catch(function (error){
        console.log(error)
      })
    }else{
      api.post('/association/change/status', data ,{
        headers: {
            Authorization: 'Bearer ' + fetchToken()
        }
      }).then(function (response){
          toast.success(response.data);
          fetch_group_loans();
          AllApprovedLoans()
          AllDisbursedLoans()
          AllRequestedLoans()
      }).catch(function (error){
        console.log(error)
      })
    }
  }
// Uploads

const fetch_docs = () => {
  api.get(`/association/get/association/group/docs/${formik_upload.values.group_id}`,{
    headers: {
        Authorization: 'Bearer ' + fetchToken()
    }
  }).then(function (response){
    setGroup_documents(response.data)
  }).catch(function (error){
    console.log(error)
  })
}

const del_doc = (doc_id) => {
  api.delete(`/association/delete/association/group/doc/${doc_id}`,{
    headers: {
        Authorization: 'Bearer ' + fetchToken()
    }
  }).then(function (response){
    toast.success(response.data);
    fetch_docs();
  }).catch(function (error){
    console.log(error)
  })
}

const handleButtonClickAct = () => {
  document.getElementById('doc').click();
}

const formik_upload = useFormik({
  initialValues: {
      doc: null,
      group_id: null
},
onSubmit: (values) => {
  if(!values.doc){
    toast.warning('No file to upload');
  }else{
    const data = new FormData()
    data.append('group_id', values.group_id)
    data.append('doc', values.doc)

    api.post('/association/post/association/group/docs', data ,{
        headers: {
            Authorization: 'Bearer ' + fetchToken()
        }
    }).then(function (response){
        toast.success(response.data);
        fetch_docs();
        formik_upload.handleReset();
        setFileName("No selected file")
        setImage(null)
    }).catch(function (error){
      console.log(error)
    })
  }
  
}
})
  const viewGroupUploads = (group_id) => {
    setUpload_open(true);
    formik_upload.setFieldValue('group_id', group_id)
  }

  useEffect(() => {
    if(formik_upload.values.group_id){
      fetch_docs()
    }
  }, [formik_upload.values.group_id])

  const closeGroupUploads = () => {
    setUpload_open(false);
    formik_upload.handleReset();
    setFileName("No selected file")
    setImage(null)
  }

  const handleFileChange = (event) => {
    const file = event.currentTarget.files[0];
    if (file) {
        setFileName(file.name);
        setImage(URL.createObjectURL(file));
        formik_upload.setFieldValue("doc", file);
    }
  };

  // end Uploads

function formatDateToYearMonthDay(date) {
  const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const day = date.getDate();
  const month = months[date.getMonth()];
  const year = date.getFullYear();
  let suffix = 'th';

  if (day === 1 || day === 21 || day === 31) {
    suffix = 'st';
  } else if (day === 2 || day === 22) {
    suffix = 'nd';
  } else if (day === 3 || day === 23) {
    suffix = 'rd';
  }

  return `${day}${suffix} ${month} ${year}`;
}

const formatDateToRelative = (date) => {
  const diff = Math.floor((new Date() - new Date(date)) / (1000 * 60 * 60 * 24));
  if (diff < 1) {
    return "Established today";
  } else if (diff < 30) {
    return `Established ${diff} ${diff === 1 ? 'day' : 'days'} ago`;
  } else if (diff < 365) {
    const months = Math.floor(diff / 30);
    return `Established ${months} ${months === 1 ? 'month' : 'months'} ago`;
  } else {
    const years = Math.floor(diff / 365);
    return `Established ${years} ${years === 1 ? 'year' : 'years'} ago`;
  }
};

const renderTitle = (name, date) => {
  const formattedDate = formatDateToYearMonthDay(date);
  const formattedDateAgo = formatDateToRelative(date);
  return (
    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
      <b style={{ margin:'5px' }}>{name} : {formattedDate}</b>
      <Chip variant='outlined' size='small' sx={{ m:'5px' }} color='success' label={formattedDateAgo} />
    </Typography>
  );
};


const viewSingle = (params) => {
  navigate('/single/disburse_form' , { state: 
    {
      one: params.row,
      association_id: props.id,
      association_data: props.association_data
    } 
  })
}



  const viewGroup = (one, what) => {
    if(what === 'production'){
      navigate('/group/print' , { state: 
        {
          one: one,
          association_id: props.id,
          association_data: props.association_data
        } 
      })
    }else{
      navigate('/group/print/cash' , { state: 
        {
          one: one,
          association_id: props.id,
          association_data: props.association_data
        } 
      })
    }
  }


  const applicationForms = () => {
    navigate('/application/print', {
      state: {
        association_id: props.id
      }
    })
  }
  
  const applicationForm = () => {
    navigate('/application/form/print', {
      state: {
        association_id: props.id
      }
    })
  }



  const fetchCrops = () => {
    api.get(`/members/farm/crops/${hold_member_id}`,{
      headers: {
        Authorization: 'Bearer '+fetchToken()
      }
    }).then(function (response){
        setFarm_crops(response.data?.data)
    }).catch(function (error){
      console.log(error)
    })
  }

  useEffect(() => {
    if(hold_member_id){
      fetchCrops();
    }
  },[hold_member_id])


const changeSliderValue = (e) => {
  setSlider_value(e.target.value);
}

const buildGroup = (typ) => {
  setName_modal(
    <GroupName
      handleConfirmBuild={handleConfirmBuild}
      typ={typ}
    />
  )
  setTypes(typ)
}


 const handleConfirmBuild = (name, type) => {
  const data = {
    'accounts': added_trs,
    'name': name,
    'association_id': props.id,
    'types': type
  }
  toast.promise(
    api.post('/association/create/association/group/loan', data,{
      headers: {
        Authorization: 'Bearer '+fetchToken()
      }
    }),
    {
      loading: 'Building Group...',
      success: (response) => {
        setName_modal();
        fetch_group_loans();

        return response.data
      },
      error: (error) => {
        console.log(error)
        return 'An error occurred'
      }
    }
  )
 }

 const fetch_group_loans = () => {
  api.get(`/association/get/association/group/loans/${props.id}`,{
    headers: {
      Authorization: 'Bearer '+fetchToken()
    }
  }).then(function (response){
    setGroups(response.data)
  }).catch(function (error){
    console.log(error)
  })

  api.get(`/association/get/association/group/loans/cash/${props.id}`,{
    headers: {
      Authorization: 'Bearer '+fetchToken()
    }
  }).then(function (response){
    setGroups_cash(response.data)
  }).catch(function (error){
    console.log(error)
  })
 }
 
  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 1100,
    maxHeight: '80vh', 
    overflowY: 'auto', 
    '&::-webkit-scrollbar': {
        width: '7px',
    },
    '&::-webkit-scrollbar-track': {
        background: '#f1f1f1',
    },
    '&::-webkit-scrollbar-thumb': {
        background: '#888',
        borderRadius: '10px',
    },
    '&::-webkit-scrollbar-thumb:hover': {
        background: '#555',
    },
    bgcolor: 'background.paper',
    border: '1px solid #e7ecef',
    borderRadius: '7px',
    boxShadow: 24,
    p: 4,
  };

  const closeMakeRequest = () => {
    setReq_modal(false);
    setReq_modal_cash(false);
    setHold_acres(null);
    setHold_crop(null);
    setHold_crop_id(null);
    setHold_member_acc_id(null)
    setHold_member_acc_id_cash(null)
    setHold_member_id(null);
    setHold_member_psb(null);
    formik.handleReset();
    setService_subscribed([]);
    setInput_subscribed([]);
    setSlider_value(1);
    setSubscribed_s([]);
    setSubscribed_i([]);
  }
  // One thing

    const openMakeRequest = (psb_id, member_id, account_id) => {
      setHold_member_id(member_id)
      setHold_member_psb(psb_id)
      setHold_member_acc_id(account_id)
      toast.promise(
        api.get(`/account/member/production/account/details/${account_id}`,{
          headers: {
            Authorization: 'Bearer '+ fetchToken()
          }
        }),
        {
          loading: 'Loading...',
          success: (response) => {
            setDetails(response.data);
            setMember_crops(response.data.crops);
            setReq_modal(true)
          },
          error: (error) => {
            console.log(error)
            return 'Network error'
          }
        }
      )
    }

    const openMakeRequestCash = (psb_id, member_id, account_id, id) => {
      setHold_member_id(member_id)
      setHold_member_psb(psb_id)
      setHold_member_acc_id_cash(account_id)
      api.get(`/account/loan/${id}`,{
        headers: {
            Authorization: 'Bearer ' + fetchToken()
        }
      }).then(function (response){
          setInfo(response.data);
          setReq_modal_cash(true);
      }).catch(function (error){
        console.log(error);
      });
    }

    const joinSeason = (passbook_id, member_id, season_id) => {
      const iinfo = new FormData();
      iinfo.append('passbook_id', passbook_id)
      iinfo.append('member_id', member_id)
      iinfo.append('season_id', season_id)
      api.post('/account/new/prod/member/account',iinfo, {
        headers: {
          Authorization: 'Bearer ' + fetchToken()
        }
      }).then(function (response){
        toast.meassage(response.data, {
          description: 'Click on season to see new updates',
        })
        handleProductionGroups();
        closeMakeRequest();
      }).catch(function(error){
        console.log(error);
      })
    }

    const activateAccount = (passbook_id, member_id, loan_acc_id) => {
      const iinfo = {
        'association_member_id': passbook_id,
        'member_id': member_id,
        'loan_id': loan_acc_id
      }
      api.post('/account/memberloan',iinfo, {
        headers: {
          Authorization: 'Bearer ' + fetchToken()
        }
      }).then(function (response){
        toast.success(response.data, {
          description: 'Click on account to see new updates',
        })
        handleProductionGroupsCash();
        closeMakeRequest();
      }).catch(function(){
        console.log(error);
      })
    }

    const openLoanProducts = (commodity, commodity_id, acres) => {
      setHold_crop(commodity);
      setHold_acres(acres);
      setHold_crop_id(commodity_id);
      toast.promise(
        api.get(`/association/production/loan/view/one/${commodity_id}`, {
            headers: {
                Authorization:'Bearer ' + fetchToken(),
            },
        }),
        {
          loading: 'Loading...',
          success: (response) => {
            const new_objects = response.data.services.map((one, index) => { 
              return {
                  index_id: subscribed_s.length + index + 1,
                  product_id: one.id,
                  interest_type: '',
                  private_interest: null,
                  interest_months: null,
                  product_type:'',
                  subscribe: false,
                  service: one.service,
                  service_price_per_acre: one.service_price_per_acre,
                  interest_percentage_rate_anum: one.interest_percentage_rate_anum
              }
            });

            setSubscribed_s([...subscribed_s, ...new_objects]);
            // inputs
            const new_object = response.data.inputs.map((one, index) => { 
                return {
                    index_id: subscribed_i.length + index + 1,
                    product_id: one.id,
                    company: one.company,
                    quantity: one.quantity_per_acre,
                    interest_type: '',
                    private_interest: null,
                    interest_months: null,
                    product_type:'',
                    subscribe: false,
                    input: one.input,
                    input_price_per_acre: one.input_price_per_acre,
                    interest_percentage_rate_anum: one.interest_percentage_rate_anum
                }
            });

            setSubscribed_i([...subscribed_i, ...new_object]);
          },
          error: (error) => {
            console.log(error)
            return 'Network error'
          }
        }
      )
  }

  const handleSummarize = () => {
    const data = {
        'acres_planting': slider_value,
        'services': subscribed_s,
        'inputs': subscribed_i
    }
    toast.promise(
      api.post('/association/summarize/subscription', data ,{
         headers: {
           Authorization: 'Bearer '+ fetchToken()
         }
       }),
       {
         loading: 'Summarizing...',
         success: (response) => {
           setService_subscribed(response.data?.services);
           setInput_subscribed(response.data?.inputs);
           setDeep_details(response.data);
           return 'Summary Done'
         },
         error: (error) => {
           console.log(error)
           return 'Network error'
         }
       }
   )
}

const handleConfirmLoan = () => {
    const data = {
        'acres_planting': slider_value,
        'services': subscribed_s,
        'inputs': subscribed_i,
        'crop_id': hold_crop_id,
        'member_acc_id': hold_member_acc_id
    }
    toast.promise(
      api.post('/association/confirmed/subscription', data ,{
        headers: {
          Authorization: 'Bearer '+ fetchToken()
        }
      }),
      {
        loading: 'Confirming...',
        success: (response) => {
          toast.success(response.data, {
            description: 'Click on account to see new updates',
          })
          closeMakeRequest();
          handleProductionGroups();
        },
        error: (error) => {
          console.log(error)
          return 'Network error'
        }
      }
    )
}
  //  One thing end

  const pic = (pic) => {
    const de = decode(pic);
    return `data:image/jpeg;base64,${btoa(de)}`;
  };

  const handleDisplaySeason = (season) => {
    setSeason_details(season);
    setSeason_season(season.season);
    toast.info('Success', {
      description: 'Click on season to see new updates',
    })
  }

  const handleDisplayAccount = (account) => {
    setAccount_details(account);
    setAccount_account(account.loan_account)
    toast.info('Success', {
      description: 'Click on account to see new updates',
    })
  }


 

  const handleProductionGroups = () => {
    toast.promise(
      api.get(`/account/prod/loan/group/form/data/${props.id}`,{
        headers: {
          Authorization: 'Bearer '+fetchToken()
        }
      }), 
      {
        loading: 'Loading...',
        success: (response) => {
          setGroup_data(response.data);
          setForm_group(true);
          closeMakeRequest();
        },
        error: (error) => {
          console.log(error)
          return 'Network error'
        }
      }
    )
  }

  const handleProductionGroupsCash = () => {
    toast.promise(
      api.get(`/account/prod/loan/group/form/data/cash/${props.id}`,{
        headers: {
          Authorization: 'Bearer '+fetchToken()
        }
      }),
      {
        loading: 'Loading...',
        success: (response) => {
          setGroup_data_cash(response.data);
          setForm_group_cash(true);
          closeMakeRequest();
        },
        error: (error) => {
          console.log(error)
          return 'Network error'
        }
      }
    )
  }


  const fetch_somthing = () => {
    api.get('/users/user/society',{
      headers: {
        Authorization: 'Bearer '+fetchToken()
      }
    }).then(function (response){
        setSoc(response.data?.Soc)
    }).catch(function (error){
      console.log(error)
    })
  }

  const fetet = () => {
    api.get('/association/societies/diff',{
      headers: {
        Authorization: 'Bearer '+fetchToken()
      }
    }).then(function (response){
        setSociety(response.data?.Society)
    }).catch(function (error){
      console.log(error)
    })
  }


  useEffect(() => {
    fetet();
    fetch_somthing();
    fetch_group_loans();
  },[])

  const handleSocietyBanks = (society_id) => {
    api.get(`/account/society/all/${society_id}`,{
      headers: {
          Authorization:'Bearer ' + fetchToken(),
      },
      }).then(function (response) {
          setAccounts(response.data);
          setNm(response.data?.Society_Name);
      }).catch(function (error){
          console.log(error)
      })
  }
  // const handleClosee = () => {
    
  // };
  // const handleDisburse = (transaction_id, amount) => {
  //   setOpenn(true);
  //   setIdd(transaction_id);
  //   setNowAmount(amount);
  // }


  // const handleConfirmDisburse = () =>{
  //   const data = new FormData()
  //   data.append("transaction_id", idd)
  //   data.append("bank_id", account_idd)

  //   api.post('/account/disburse/funds/member/loan', data,{
  //       headers: {
  //           Authorization:'Bearer ' + fetchToken(),
  //       },
  //       }).then(function (response) {
  //           handleClosee()
  //           toast.success(response.data)
  //       }).catch(function (error){
  //           console.log(error)
  //       }).finally(function (){
  //           fetchExpenses()
  //       });
  // }


    const AllRequestedLoans = () =>{
      api.get(`/association/loans/info/${props.id}`, {
        headers: {
          Authorization: 'Bearer '+ fetchToken()
        },
      }).then(function (response){
        setRequestedLoans(response.data?.results);
        setReg_amount_sum(response.data?.total);
      }).catch(function (error){
        console.log(error)
      })
    }
    // console.log(props.id)
    // console.log(requestedLoans)

    const AllRequestedLoansFiltered = () =>{
        const floridaa = new FormData()
        floridaa.append('association_id', props.id)
        floridaa.append('start_date', start_date)
        floridaa.append('end_date', end_date)

        toast.promise(
          api.post('/association/loans/info', floridaa, {
            headers: {
              Authorization: 'Bearer '+ fetchToken()
            },
          }),
          {
            loading: 'Filtering...',
            success: (response) => {
              setRequestedLoans(response.data?.results);
              setReg_amount_sum(response.data?.total);
            },
            error: (error) => {
              console.log(error)
              return 'Network error'
            }
          }
        )
    }

  useEffect(() => {
    AllRequestedLoans();
  },[])

 
  


  const Rcolumns = [
    {
        field: "Transaction_id",
        headerName: "Id",
        flex:1,
        width: 70,
    },
    {
      field: "Member_name",
      headerName: "Member name",
      flex:1,
      width: 70,
    },
    {
        field: "Transaction_date",
        headerName: 'DateTime',
        flex: 1,
        cellClassName: "name-column--cell",
        renderCell:(params) => <FormatedDate value={params.row.Transaction_date}/>
    },
    {
        field: "Amount",
        headerName: "Amount(GH₵)",
        flex:1,
        width: 70,
        renderCell:(params) => currencyFormat.format(params.row.Amount)
    },
    {
      field: "Recommended_Amount",
      headerName: "Recommended_Amount",
      flex:1,
      width: 70,
      renderCell:(params) => currencyFormat.format(params.row.Recommended_Amount)
    },
    {
        field: "Narration",
        headerName: "Narration",
        flex:1,
        width: 70,
    },
    {
        field: "Prepared_by",
        headerName: "Prepared by",
        flex:1,
        width: 70,
    },
    {
      field: "Member_id",
      headerName: "Member id",
      flex:1,
      width: 70,
    },
    {
      field: "type",
      headerName: "Type",
      flex:1,
      width: 70,
      renderCell:(params) => params.row.type === "commodity"? "Commodity Loan": "Cash Loan"
    },
    {
      field: "action",
      type: 'actions',
      headerName: "Approve",
      flex:1,
      width: 70,
      getActions: (params: GridRowParams) => [
        <GridActionsCellItem
        icon={<RecommendIcon />}
        onClick={() => handleClickApprover(params.row.Transaction_id)} 
        label="Open"
      />]
    },
    {
      field: 'actions',
      type: 'actions',
      headerName: "Member Detail",
     getActions: (params: GridRowParams) => [
        <GridActionsCellItem
        icon={<MoreIcon />}
        onClick={() => handlePsb(params)} 
        label="Open"
      />]
    }
  ]

  const [id_transaction, setId_transaction] = useState(null);
  const [approval_message, setApproval_message] = useState("");
  const [recommended_amount, setRecommended_amount] = useState(null);
  const [open_dialog, setOpen_Dialog] = useState(false);
  const [apr_info, setApr_Info] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleClickApprover = (id) => {
    setId_transaction(id)
    setOpen_Dialog(true)
    api.get(`/transactions/member/for_approval/${id}`, {
      headers: {
        Authorization: 'Bearer '+ fetchToken()
      },
    }).then(function (response){
      setApr_Info(response.data)
      setRecommended_amount(response.data.Member_Details.recommended_amount)
      setApproval_message(response.data.Member_Details.message)
    }).catch(function (error){
      console.log(error)
    })
  };


  const approve_it_wai = (event) => {
    event.preventDefault()

    const formData = new FormData();
    formData.append('transaction_id', id_transaction);
    formData.append('approval_message', approval_message)
    formData.append('recommended_amount', recommended_amount)
    const headers = {
      Authorization: 'Bearer ' + fetchToken(),
      'Content-Type': 'multipart/form-data', 
    };
    toast.promise(
      api
        .patch(`/transactions/approve/loan`, formData, { headers: headers }),
        {
          loading: 'Loading...',
          success: (res) => {
            AllRequestedLoans();
            AllApprovedLoans();
            AllDisbursedLoans();
            setApproval_message("");
            setRecommended_amount(null)
            setOpen_Dialog(false);
            
            return res.data
          },
          error: (err) => {
            console.log(err)
            return 'An Error Occurred'
          }
        }
    )
  }

  const disapproved = () => {
    const dhj = new FormData()
    dhj.append('transaction_id', id_transaction)
    api.patch('/transactions/disapprove/loan/now', dhj, {
      headers: {
        Authorization: 'Bearer '+ fetchToken()
      },
    }).then(function (response){
        toast.success(response.data)
        AllRequestedLoans();
        AllApprovedLoans();
        AllDisbursedLoans();
        setRecommended_amount(null)
        setOpen_Dialog(false);
        setOpen(false)
    }).catch(function (error){
      console.log(error)
    })
  }

  const handleCloseAppro = () => {
    setOpen_Dialog(false);
    setId_transaction(null);
  }



    const AllApprovedLoans = () =>{
      api.get(`/association/loans/approved/${props.id}`, {
        headers: {
          Authorization: 'Bearer '+ fetchToken()
        },
      }).then(function (response){
          setApprovedLoans(response.data?.results);
          setApr_amount_sum(response.data?.total);
      }).catch(function (error){
        console.log(error)
      })
    }


    const AllApprovedLoansFiltered = () =>{
      const los_angeles = new FormData()
      los_angeles.append('association_id', props.id)
      los_angeles.append('start_date', start_date_apr)
      los_angeles.append('end_date', end_date_apr)

      toast.promise(
        api.post('/association/loans/approved', los_angeles,{
          headers: {
            Authorization: 'Bearer '+ fetchToken()
          },
        }),
        {
          loading: 'Filtering...',
          success: (response) => {
            setApprovedLoans(response.data?.results);
            setApr_amount_sum(response.data?.total);
          },
          error: (error) => {
            console.log(error)
            return 'Network error'
          }
        }
      )
    }

  useEffect(() => {
    AllApprovedLoans();
  },[])


  const columns = [
    {
        field: "Transaction_id",
        headerName: "Id",
        flex:1,
        width: 70,
    },
    {
      field: "Member_name",
      headerName: "Member name",
      flex:1,
      width: 70,
    },
    {
        field: "Transaction_date",
        headerName: 'DateTime',
        flex: 1,
        cellClassName: "name-column--cell",
        renderCell:(params) => <FormatedDate value={params.row.Transaction_date}/>
    },
    {
        field: "Amount",
        headerName: "Amount(GH₵)",
        flex:1,
        width: 70,
        renderCell:(params) => currencyFormat.format(params.row.Amount)
    },
    {
        field: "Recommended_amount",
        headerName: "Recommended amount",
        flex:1,
        width: 70,
        renderCell:(params) => currencyFormat.format(params.row.Recommended_amount)
    },
    {
        field: "Narration",
        headerName: "Narration",
        flex:1,
        width: 70,
    },
    {
      field: "balance",
      headerName: "Account balance",
      flex:1,
      width: 70,
      renderCell:(params) => currencyFormat.format(params.row.balance)
    },
    {
      field: "Member_id",
      headerName: "Member id",
      flex:1,
      width: 70,
    },
    {
      field: "action",
      type: 'actions',
      headerName: "Disburse",
      flex:1,
      width: 70,
      getActions: (params: GridRowParams) => [
        <GridActionsCellItem
        icon={<RecommendIcon />}
        onClick={() => handleClickApp(params.row.Transaction_id, params.row.Amount, params.row.Recommended_amount)} 
        label="Open"
      />]
    },
    {
      field: 'actions',
      type: 'actions',
      headerName: "Member Detail",
     getActions: (params: GridRowParams) => [
        <GridActionsCellItem
        icon={<MoreIcon />}
        onClick={() => handlePsb(params)} 
        label="Open"
      />]
    }
  ]
    const AllDisbursedLoans = () =>{
      api.get(`/association/loans/disbursed/${props.id}`, {
        headers: {
          Authorization: 'Bearer '+ fetchToken()
        },
      }).then(function (response){
        setDisbursedLoans(response.data?.results);
        setDis_amount_sum(response.data?.total);
      }).catch(function (error){
        console.log(error)
      })
    }

    const AllDisbursedLoansFiltered = () =>{
      const new_york = new FormData()
      new_york.append('association_id', props.id)
      new_york.append('start_date', start_date_dis)
      new_york.append('end_date', end_date_dis) 
      api.post('/association/loans/disbursed', new_york, {
        headers: {
          Authorization: 'Bearer '+ fetchToken()
        },
      }).then(function (response){
        setDisbursedLoans(response.data?.results);
        setDis_amount_sum(response.data?.total);
      }).catch(function (error){
        console.log(error)
      })
    }

  useEffect(() => {
    AllDisbursedLoans();
  },[])


  const DisColumns = [
    {
        field: "Transaction_id",
        headerName: "Id",
        flex:1,
        
    },
    {
      field: "Member_name",
      headerName: "Member name",
      flex:1,
      
    },
    {
        field: "Transaction_date",
        headerName: 'DateTime',
        flex: 1,
        cellClassName: "name-column--cell",
        renderCell:(params) => <FormatedDate value={params.row.Transaction_date}/>
    },
    {
        field: "Amount",
        headerName: "Amount(GH₵)",
        flex:1,
        
        renderCell:(params) => currencyFormat.format(params.row.Amount)
    },
    {
        field: "Recommended_amount",
        headerName: "Recommended amount",
        flex:1,
        
        renderCell:(params) => currencyFormat.format(params.row.Recommended_amount)
    },
    {
      field: "Repayment_starts",
      headerName: "Repayment starting date",
      flex:1,
      
    },
    {
      field: "Repayment_ends",
      headerName: "Repayment ending date",
      flex:1,
      
    },
    {
      field: "account_name",
      headerName: "Loan Product",
      flex:1,
      
    },
    {
      field: "interest_amount",
      headerName: "Interest Amount",
      flex:1,
      
    },
    {
      field: "period",
      headerName: "Period",
      flex:1,
      
    },
    {
      field: "Member_id",
      headerName: "Member id",
      flex:1,
      
    },
    {
      field: "type",
      headerName: "Type",
      flex:1,
      
    },
    {
      field: "action",
      type: 'actions',
      headerName: "Loan Advise",
      flex:1,
      
      getActions: (params: GridRowParams) => [
        <GridActionsCellItem
        icon={<VisibilityOutlinedIcon />}
        onClick={() => printLoanAdvise(params.row.Transaction_id, params.row.type)} 
        label="Open"
      />]
    },
    {
      field: "action1",
      type: 'actions',
      headerName: "Disbursement Form",
      flex:1,
      getActions: (params: GridRowParams) => [
        <GridActionsCellItem
        icon={<StickyNote2RoundedIcon />}
        onClick={() => viewSingle(params)}
        label="Open"
      />]
    },
    {
      field: 'actions',
      type: 'actions',
      headerName: "Member Detail",
     getActions: (params: GridRowParams) => [
        <GridActionsCellItem
        icon={<MoreIcon />}
        onClick={() => handlePsb(params)} 
        label="Open"
      />]
    }
  ]

  
    const handlePsb = (params) => {
      navigate('/onemember/', {state: {
        Member_id: params.row.Member_id,
        Fullname: `${params.row.Member_name}`,
      } })
    };
      
  const handleClickApp = (id, amount, rec_amount) => {
    setOpen(true);
    setMessageid(id);
    handleClickApprover(id)
    setIdd(id);
    setNowAmount(amount);
    setNowAmountat(rec_amount);
  };

  const handleClose = () => {
    setOpen(false);
    setOpen_Dialog(false)
    setIdd()
    setNowAmount(null)
    setNowAmountat(null)
    setTransferDetails([]);
    setAccount_idd();
  };
  const [repaymentTimes, setRepaymentTimes] = useState("");

  const handleDisburseConfirmation = (type, account_id) => {
    const data = new FormData()
    if (typese === 'cash'){
      data.append("transaction_id", hold_group_id)
    }else{
      data.append("transaction_id", idd)
    }
    
    if(type === 'ecash'){
      data.append("ecash_id", account_id);
      setEcash(true)
    }
    if(type === 'bank'){
      data.append("bank_id", account_id);
      setEcash(false)
    }
    data.append("group", typese === 'cash'? true:false)
    
    setAccount_idd(account_id)
    api.post('/account/payment/details/member', data,{
      headers: {
          Authorization:'Bearer ' + fetchToken(),
      },
    }).then(function (response) {
        setTransferDetails(response.data);
    }).catch(function (error){
        console.log(error)
    })
  }
 
  const handleClickApprove = async (event) => {
      event.preventDefault()

  
    const formData = new FormData();

    formData.append('transaction_id', messageid?messageid:0)
    formData.append('repayment_starts', repayment_starts)
    formData.append('num_of_weeks_to_end_payment', num_of_weeks_to_end_payment)
    formData.append('interest_period', interest_period)
    formData.append('repaymentTimes', repaymentTimes)
    if(ecash){
      formData.append("ecash_id", account_idd);
    }
    if(!ecash){
      formData.append("bank_id", account_idd);
    }
    formData.append("types", typese)
    formData.append("group_id", hold_group_id?hold_group_id:0)

  toast.promise(
    api.patch(`/transactions/disburse/loan`, formData,{
        headers: {
            Authorization:'Bearer ' + fetchToken(),
        },
      }),
      {
        loading: 'Loading...',
        success: (res) => {
          handleClose();
          setRepayment_starts('');
          setNum_of_weeks_to_end_payment('');
          AllRequestedLoans();
          AllApprovedLoans();
          AllDisbursedLoans();
          handleCloseAppro();
          return res.data
        },
        error: (err) => {
          console.log(err)
          return 'An error occured'
        }
      }
  )
  };


  
 

  const printLoanAdvise = (id, type) => {
    if(permissions && permissions.download_loan_advise === true){
      if(type === "commodity"){
        api.get(`/transactions/loan/advise/commodity/${id}`, {
          headers: {
            Authorization: 'Bearer '+ fetchToken()
          },
        }).then(function (response){
            setOpennn(<LoanAdviseCommodity Loan_Details={response.data?.Loan_Details} More_Details={response.data?.More_Details} Transaction_Details={response.data?.Transaction_Details} Repayment_Schedule={response.data?.Repayment_Schedule}  Amount_Total={response.data?.Amount_Total} Interest_Total={response.data?.Interest_Total} Total_Khraa={response.data?.Total_Khraa} />)
        }).catch(function (error){
          console.log(error);
        });
      }else{
        api.get(`/transactions/loan/advise/${id}`, {
          headers: {
            Authorization: 'Bearer '+ fetchToken()
          },
        }).then(function (response){
            setOpennn(<LoanAdvise Loan_Details={response.data?.Loan_Details} More_Details={response.data?.More_Details} Transaction_Details={response.data?.Transaction_Details} Repayment_Schedule={response.data?.Repayment_Schedule}  Amount_Total={response.data?.Amount_Total} Interest_Total={response.data?.Interest_Total} Total_Khraa={response.data?.Total_Khraa} />)
        }).catch(function (error){
          console.log(error);
        });
      }
      
    }else{
      toast.error("Not Authorized")
    }
  };

  

  // console.log(apr_info)
  // console.log(loanDetails, moreDetails);

  const getInitials = (firstName, lastName) => {
    const firstInitial = firstName ? firstName.charAt(0) : '';
    const lastInitial = lastName ? lastName.charAt(0) : '';
    return `${firstInitial}${lastInitial}`;
  };

  const CustomFooterRow = (type) => {
    return (
      <div>
        <div style={{ display: 'flex', padding: '4px' }}>
          <Typography variant="h5" fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
           sx={{ color:'red', mr:4 }}>Total:</Typography>
          <Typography variant="h5" fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
           sx={{ color:'darkblue', mr:4 }}><b>{`Amount: ${type === 'reg'? currencyFormat.format(reg_amount_sum): type === 'apr'? currencyFormat.format(apr_amount_sum): currencyFormat.format(dis_amount_sum)}`}</b></Typography>
        </div>
      </div>
    );
  };


  return (
    <div>
      <Chip
        variant="outlined"
        label={
          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
              <b>Loan Application Form</b>
          </Typography>
        }
        sx={{
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)',
            minWidth: 0,
            m:1,
            backgroundColor:'#2b2d42',
            color:'#fff',
            '&:hover': {
              boxShadow: '0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)',
              backgroundColor:'#14213d',
            },
        }} 
        size='small'
        onClick={applicationForm}
      />
      <Accordion sx={{ borderRadius:2, mb:2 }}>
        <AccordionSummary
            expandIcon={<ExpandMore />}
            aria-controls="panel1a-content"
            id="panel1a-header"
            display='flex'
        >
            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" sx={{ mr: 'auto' }}><b>Production Group Loans</b></Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container spacing={2}>
            <Grid item xs={12} md={12}>
                <Chip
                  variant="outlined"
                  label={
                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>Form loan group</b>
                    </Typography>
                  }
                  sx={{
                      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)',
                      minWidth: 0,
                      m:1,
                      backgroundColor:'#2b2d42',
                      color:'#fff',
                      '&:hover': {
                        boxShadow: '0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)',
                        backgroundColor:'#14213d',
                      },
                  }} 
                  size='small'
                  onClick={handleProductionGroups}
                />
              </Grid>
              <Grid item xs={12} md={12}>
                {
                  groups[0]?
                  <Box sx={{ display:'flex', marginBottom:1, flexWrap:'wrap', maxWidth: '100%', overflowX: 'auto', '&::-webkit-scrollbar': {
                      height: '5px',
                    },
                    '&::-webkit-scrollbar-track': {
                        background: '#f1f1f1',
                    },
                    '&::-webkit-scrollbar-thumb': {
                        background: '#888',
                        borderRadius: '10px',
                    },
                    '&::-webkit-scrollbar-thumb:hover': {
                        background: '#555',
                  }}}>
                      {
                        groups.map((one) => (
                          <Card sx={{ m:1, width:450, borderRadius:7, boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)'}}>
                            <CardHeader
                                title={<Typography variant='h5' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>{one?.group_name}</b></Typography>}
                            />
                            <CardContent>
                            <Box sx={{ display: 'block', justifyContent:'space-between' }}>
                              <div>{renderTitle('Established Date', new Date(one?.date_created))}</div>
                              <div><Typography sx={{ m:'5px' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Season: {one?.season}</b></Typography></div>
                              <div style={{ margin:'10px' }}>
                                <Chip
                                  variant="contained"
                                  onDelete={doNothing}
                                  deleteIcon={one?.approved === 'Yes'?<CheckCircleIcon />: null}
                                  onClick={() => groupStat('approve', one.id ,'production', 0)}
                                  label={<Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Approved</b></Typography>}
                                  sx={{
                                    color:'#000',
                                    backgroundColor: "#f5f3f4",
                                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)',
                                    '&:hover': {
                                      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)',
                                      backgroundColor:'#bc6c25',
                                      color:'#fff',
                                    },
                                  }} 
                                  size='small'
                                />
                              </div>
                              <div style={{ margin:'10px' }}>
                                <Chip
                                    variant="contained"
                                    onDelete={doNothing}
                                    deleteIcon={one?.signed === 'Yes'?<CheckCircleIcon />: null}
                                    onClick={() => groupStat('signed', one.id ,'production', 0)}
                                    label={<Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Signed</b></Typography>}
                                    sx={{
                                      color:'#000',
                                      backgroundColor: "#f5f3f4",
                                      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)',
                                      '&:hover': {
                                        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)',
                                        backgroundColor:'#bc6c25',
                                        color:'#fff',
                                      },
                                    }} 
                                    size='small'
                                />
                              </div>
                              <div style={{ margin:'10px' }}>
                                <Chip
                                  variant="contained"
                                  onDelete={doNothing}
                                  deleteIcon={one?.disbursed === 'Yes'?<CheckCircleIcon />: null}
                                  onClick={() => groupStat('disbursed', one.id ,'production', 0)}
                                  label={<Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Disbursed</b></Typography>}
                                  sx={{
                                    color:'#000',
                                    backgroundColor: "#f5f3f4",
                                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)',
                                    '&:hover': {
                                      boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)',
                                      backgroundColor:'#bc6c25',
                                      color:'#fff',
                                    },
                                  }} 
                                  size='small'
                                />
                              </div>
                            </Box>
                            </CardContent>
                            <CardActions>
                              <div>
                                <Chip
                                    variant="contained"
                                    onClick={() => viewGroup(one, 'production')}
                                    label={<Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Prints</b></Typography>}
                                    sx={{
                                      color:'#fff',
                                      backgroundColor: "#eb5e28",
                                      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)',
                                      minWidth: 0,
                                      '&:hover': {
                                        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)',
                                        backgroundColor:'#bc6c25',
                                        color:'#fff',
                                      },
                                    }} 
                                    size='small'
                                />
                              </div>
                              <div>
                                <Chip
                                    variant="contained"
                                    onClick={() => viewGroupUploads(one.id)}
                                    label={<Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Uploads</b></Typography>}
                                    sx={{
                                      color:'#fff',
                                      backgroundColor: "#eb5e28",
                                      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)',
                                      minWidth: 0,
                                      '&:hover': {
                                        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)',
                                        backgroundColor:'#bc6c25',
                                        color:'#fff',
                                      },
                                    }} 
                                    size='small'
                                />
                              </div>
                            </CardActions>
                        </Card>
                        ))
                      }
                    </Box>
                  :
                  <Box sx={{ m:'auto' }}>
                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" sx={{ mr: 'auto' }}><b>No Group Loans Established</b></Typography>
                  </Box>
                }
              </Grid>
            
            

            {
              form_group?
              <Grid item xs={12} md={12}>
                <Grid container spacing={2}>
                  <Grid item xs={12} md={12}>
                    <Box 
                      sx={{ 
                          display:'flex',
                          overflowX: 'auto', 
                          marginTop:'5px',
                          maxWidth: 1500, 
                          '&::-webkit-scrollbar': {
                            height: '5px',
                          },
                          '&::-webkit-scrollbar-track': {
                              background: '#f1f1f1',
                          },
                          '&::-webkit-scrollbar-thumb': {
                              background: '#888',
                              borderRadius: '10px',
                          },
                          '&::-webkit-scrollbar-thumb:hover': {
                              background: '#555',
                          }
                      }}
                    >
                      {
                        group_data[0]?
                        group_data?.map((season) => (
                          <Chip
                            size='small'
                            label={<Typography variant='subtitle' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>{season.season}</b></Typography>}
                            sx={{
                              borderRadius:2,
                              m:1,
                              boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)',
                              backgroundColor:'#2b2d42',
                              color:'#fff',
                              '&:hover': {
                                boxShadow: '0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)',
                                backgroundColor:'#14213d',
                              },
                            }} 
                            onClick={() => handleDisplaySeason(season)} 
                          />
                        ))
                        :null
                      }
                    </Box>
                  </Grid>
                  {
                    season_details?
                    <Grid item xs={12} md={12}>
                      <Typography variant='subtitle' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>{season_season}</b></Typography>
                      <Chip
                        size='small'
                        label={<Typography variant='subtitle' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Build Group</b></Typography>}
                        sx={{
                          borderRadius:2,
                          m:1,
                          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)',
                          backgroundColor:'#2b2d42',
                          color:'#fff',
                          '&:hover': {
                            boxShadow: '0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)',
                            backgroundColor:'#14213d',
                          },
                        }}
                        disabled={added_trs[0]? false: true}
                        onClick={() => buildGroup('production')} 
                      />
                      <List 
                          sx={{ 
                            maxHeight: "70vh", 
                            overflow:'auto',
                            '&::-webkit-scrollbar': {
                              width: '5px',
                              height: '4px'
                            },
                            '&::-webkit-scrollbar-track': {
                                background: '#f1f1f1',
                            },
                            '&::-webkit-scrollbar-thumb': {
                                background: '#888',
                                borderRadius: '10px',
                            },
                            '&::-webkit-scrollbar-thumb:hover': {
                                background: '#555',
                            } 
                          }}
                        >
                          {
                            season_details?.members.map((member) => (
                              <>
                              <ListItem
                                sx={{ backgroundColor:'#dee2e6' ,borderRadius:5, m:2 }}
                                alignItems="flex-start"
                                secondaryAction={<>
                                {
                                  member.in_it?
                                  <Tooltip title={
                                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                      Member already registered in group
                                    </Typography>
                                  }>
                                    <Chip
                                    size='small'
                                    label={<Typography variant='subtitle' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                          {
                                            member.stat === "account"? added_trs.findIndex(item => item.MemAcId === member.member_account_id) !== -1 ?
                                            <b>Remove</b> :
                                            <b>Add to group</b>
                                            :member.stat === "no_account"?
                                            <b>Join Season</b>
                                            :member.stat === "no_transaction"?
                                            <b>Make Request</b>
                                            :null
                                          }
                                        </Typography>
                                      }
                                    sx={{
                                      m:1,
                                      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)',
                                      backgroundColor:'#eb5e28',
                                      color:'#fff',
                                      '&:hover': {
                                        boxShadow: '0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)',
                                        backgroundColor:'#bc6c25',
                                      },
                                    }}
                                  />
                                  </Tooltip>
                                  :
                                  <Chip
                                    size='small'
                                    label={<Typography variant='subtitle' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                          {
                                            member.stat === "account"? added_trs.findIndex(item => item.MemAcId === member.member_account_id) !== -1 ?
                                            <b>Remove</b> :
                                            <b>Add to group</b>
                                            :member.stat === "no_account"?
                                            <b>Join Season</b>
                                            :member.stat === "no_transaction"?
                                            <b>Make Request</b>
                                            :null
                                          }
                                        </Typography>
                                      }
                                    sx={{
                                      m:1,
                                      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)',
                                      backgroundColor:'#eb5e28',
                                      color:'#fff',
                                      '&:hover': {
                                        boxShadow: '0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)',
                                        backgroundColor:'#bc6c25',
                                      },
                                    }} 
                                    onClick={() =>{
                                      if(member.stat === "account"){
                                        const existingIndex = added_trs.findIndex(item => item.MemAcId === member.member_account_id);
                                        if (existingIndex !== -1) {
                                          const updated_trs = [...added_trs];
                                          updated_trs.splice(existingIndex, 1);
                                          setTypes("production")
                                          setAdded_trs(updated_trs);
                                        } else {
                                          setTypes("production")
                                          setAdded_trs(prevState => [...prevState, {'MemAcId': member.member_account_id}]);
                                        }
                                      }else if(member.stat === "no_account"){
                                        joinSeason(member.passbook_id, member.member_id, season_details?.season_id)
                                      }else if(member.stat === "no_transaction"){
                                        openMakeRequest(member.passbook_id, member.member_id, member.member_account_id)
                                      }
                                    }}
                                  />
                                }
                                  
                                  {/* <IconButton onClick={() => handleProductionGroups()}><Refresh /></IconButton> */}
                                  </>
                                }
                              >
                                <ListItemAvatar>
                                  <Avatar sx={{ width: 55, height: 55, mr:1 }} alt={member.member_name} src={pic(member.member_image)} />
                                </ListItemAvatar>
                                <ListItemText
                                  primary={member.member_name}
                                  secondary={
                                    <Box sx={{ display:'block' }}>
                                    <div>
                                      <Typography
                                        sx={{ display: 'inline' }}
                                        component="span"
                                        variant="body2"
                                        color="text.primary"
                                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                      >
                                        <b>Contact: {member.member_phone}</b>
                                      </Typography>
                                    </div>
                                    {
                                      member?.loan_products? 
                                      member?.loan_products?.map((product) => (
                                        <div style={{ maxHeight: 250, overflowY:'scroll',
                                              '&::-webkit-scrollbar': {
                                                width: '3px',
                                              },
                                              '&::-webkit-scrollbar-track': {
                                                  background: '#f1f1f1',
                                              },
                                              '&::-webkit-scrollbar-thumb': {
                                                  background: '#888',
                                                  borderRadius: '10px',
                                              },
                                              '&::-webkit-scrollbar-thumb:hover': {
                                                  background: '#555',
                                              } ,
                                              width:'90%'
                                            }}>
                                          <Accordion sx={{ borderRadius:2, mb:2, width: '95%' }}>
                                            <AccordionSummary
                                                expandIcon={<ExpandMore />}
                                                aria-controls="panel1a-content"
                                                id="panel1a-header"
                                                display='flex'
                                            >
                                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" sx={{ mr: 'auto' }}><b>{product?.crop}</b></Typography>
                                              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>cost: {currencyFormat.format(product?.loan_cost)}</b></Typography>
                                            </AccordionSummary>
                                            <Divider variant='middle'/>
                                            <AccordionDetails>
                                              <Grid container spacing={2}>
                                                <Grid item xs={12} md={12} sx={{ display:'flex' }}>
                                                  <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" sx={{ mr: 'auto' }}><b>Planting: {product?.acres} acres</b></Typography>
                                                </Grid>

                                                <Grid item xs={12} md={6}>
                                                  <Grid container spacing={2}>
                                                    <Grid item xs={12} md={12}>
                                                      <Typography sx={{ textAlign:'center' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                        <b>Services</b>
                                                      </Typography>
                                                      <Divider variant='middle'/>
                                                    </Grid>

                                                    <Grid item xs={12} md={12}>
                                                      <List 
                                                        sx={{ 
                                                          maxHeight: "170vh", 
                                                          overflow:'auto',
                                                          '&::-webkit-scrollbar': {
                                                            width: '4px',
                                                            height: '4px'
                                                          },
                                                          '&::-webkit-scrollbar-track': {
                                                              background: '#f1f1f1',
                                                          },
                                                          '&::-webkit-scrollbar-thumb': {
                                                              background: '#888',
                                                              borderRadius: '10px',
                                                          },
                                                          '&::-webkit-scrollbar-thumb:hover': {
                                                              background: '#555',
                                                          } 
                                                        }}
                                                      >
                                                        {
                                                          product?.services.map((service) => (
                                                            <>
                                                              <ListItem
                                                                alignItems="flex-start"
                                                                secondaryAction={
                                                                  service.personal_interest && service.interest_type !== 'flat_rate'?
                                                                  <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                                    <b>Period: {service.months}</b>
                                                                  </Typography>
                                                                  :null
                                                                }
                                                                sx={{ m:1, backgroundColor:'#e9ecef', borderRadius:4 }}
                                                              >
                                                                <ListItemText
                                                                  primary={service.service}
                                                                  secondary={
                                                                    <Box sx={{ display:'block' }}>
                                                                      <div>
                                                                        <Typography
                                                                          sx={{ display: 'inline' }}
                                                                          component="span"
                                                                          variant="body2"
                                                                          color="text.primary"
                                                                          fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                                                        >
                                                                          <b>Service cost: {currencyFormat.format(service.cost)}</b>
                                                                        </Typography>
                                                                      </div>
                                                                      {
                                                                        service.personal_interest?
                                                                        <>
                                                                          <div>
                                                                            <Typography
                                                                              sx={{ display: 'inline' }}
                                                                              component="span"
                                                                              variant="body2"
                                                                              color="text.primary"
                                                                              fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                                                            >
                                                                              {
                                                                              service.interest_type === 'flat_rate'?
                                                                              <b>Private interest: {currencyFormat.format(service.personal_interest)}</b>
                                                                              :<b>Private interest: {service.personal_interest} %</b>
                                                                            }
                                                                            </Typography>
                                                                          </div>
                                                                          <div>
                                                                            <Typography
                                                                              sx={{ display: 'inline' }}
                                                                              component="span"
                                                                              variant="body2"
                                                                              color="text.primary"
                                                                              fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                                                            >
                                                                              {
                                                                                service.interest_type === 'flat_rate'?
                                                                                  <b>Interest type: Fixed Amount</b>
                                                                                :
                                                                                  <b>Interest type: Percentage rate</b>
                                                                              }
                                                                              
                                                                            </Typography>
                                                                          </div>
                                                                        </>
                                                                        :null
                                                                      }
                                                                      
                                                                    </Box>
                                                                  }
                                                                >

                                                                </ListItemText>
                                                              </ListItem>
                                                              <Divider variant='middle'/>
                                                            </>
                                                          ))
                                                        }
                                                      </List>
                                                    </Grid>
                                                  </Grid>
                                                </Grid>

                                                <Grid item xs={12} md={6}>
                                                <Grid container spacing={2}>
                                                    <Grid item xs={12} md={12}>
                                                      <Typography sx={{ textAlign:'center' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                        <b>Inputs</b>
                                                      </Typography>
                                                      <Divider variant='middle'/>
                                                    </Grid>

                                                    <Grid item xs={12} md={12}>
                                                      <List 
                                                        sx={{ 
                                                          maxHeight: "170vh", 
                                                          overflow:'auto',
                                                          '&::-webkit-scrollbar': {
                                                            width: '4px',
                                                            height: '4px'
                                                          },
                                                          '&::-webkit-scrollbar-track': {
                                                              background: '#f1f1f1',
                                                          },
                                                          '&::-webkit-scrollbar-thumb': {
                                                              background: '#888',
                                                              borderRadius: '10px',
                                                          },
                                                          '&::-webkit-scrollbar-thumb:hover': {
                                                              background: '#555',
                                                          } 
                                                        }}
                                                      >
                                                        {
                                                          product?.inputs.map((input) => (
                                                            <>
                                                              <ListItem
                                                                alignItems="flex-start"
                                                                secondaryAction={
                                                                  <>
                                                                  {
                                                                    input.personal_interest?
                                                                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                                        <b>Period: {input.months}</b>
                                                                      </Typography>
                                                                    :null
                                                                  }
                                                                  <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                                    <b>Quantity: {input.total_quantity} (kg/g/liters/...)</b>
                                                                  </Typography>
                                                                  </>
                                                                }
                                                                sx={{ m:1, backgroundColor:'#e9ecef', borderRadius:4 }}
                                                              >
                                                                <ListItemText
                                                                  primary={input.input}
                                                                  secondary={
                                                                    <Box sx={{ display:'block' }}>
                                                                      <div>
                                                                        <Typography
                                                                          sx={{ display: 'inline' }}
                                                                          component="span"
                                                                          variant="body2"
                                                                          color="text.primary"
                                                                          fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                                                        >
                                                                          <b>Company: {input.company}</b>
                                                                        </Typography>
                                                                      </div>
                                                                      <div>
                                                                        <Typography
                                                                          sx={{ display: 'inline' }}
                                                                          component="span"
                                                                          variant="body2"
                                                                          color="text.primary"
                                                                          fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                                                        >
                                                                          <b>Input cost: {currencyFormat.format(input.cost)}</b>
                                                                        </Typography>
                                                                      </div>
                                                                      {
                                                                        input.personal_interest?
                                                                        <>
                                                                          <div>
                                                                            <Typography
                                                                              sx={{ display: 'inline' }}
                                                                              component="span"
                                                                              variant="body2"
                                                                              color="text.primary"
                                                                              fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                                                            >
                                                                              {
                                                                              input.interest_type === 'flat_rate'?
                                                                              <b>Private interest: {currencyFormat.format(input.personal_interest)}</b>
                                                                              :<b>Private interest: {input.personal_interest} %</b>
                                                                            }
                                                                            </Typography>
                                                                          </div>
                                                                          <div>
                                                                            <Typography
                                                                              sx={{ display: 'inline' }}
                                                                              component="span"
                                                                              variant="body2"
                                                                              color="text.primary"
                                                                              fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                                                            >
                                                                              {
                                                                                input.interest_type === 'flat_rate'?
                                                                                  <b>Interest type: Fixed Amount</b>
                                                                                :
                                                                                  <b>Interest type: Percentage rate</b>
                                                                              }
                                                                              
                                                                            </Typography>
                                                                          </div>
                                                                        </>
                                                                        :null
                                                                      }
                                                                      
                                                                    </Box>
                                                                  }
                                                                >

                                                                </ListItemText>
                                                              </ListItem>
                                                              <Divider variant='middle'/>
                                                            </>
                                                          ))
                                                        }
                                                      </List>
                                                    </Grid>
                                                  </Grid>
                                                </Grid>
                                              </Grid>
                                            </AccordionDetails>
                                          </Accordion>
                                        </div>
                                      ))
                                      :null
                                    }
                                    
                                      
                                    </Box>
                                  }
                                />
                              </ListItem>
                            <Divider variant="inset" component="li" />
                            </>
                            ))
                          }
                        </List>
                      </Grid>
                    :null
                  }
                </Grid>
              </Grid>
              :null
            }
          </Grid>
        </AccordionDetails>
      </Accordion>

      <Accordion sx={{ borderRadius:2, mb:2 }}>
        <AccordionSummary
            expandIcon={<ExpandMore />}
            aria-controls="panel1a-content"
            id="panel1a-header"
            display='flex'
        >
            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" sx={{ mr: 'auto' }}><b>Cash Group Loans</b></Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container spacing={2}>
            <Grid item xs={12} md={12}>
            <Chip
              variant="outlined"
              label={
                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                    <b>Form loan group</b>
                </Typography>
              }
              sx={{
                  boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)',
                  minWidth: 0,
                  m:1,
                  backgroundColor:'#2b2d42',
                  color:'#fff',
                  '&:hover': {
                    boxShadow: '0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)',
                    backgroundColor:'#14213d',
                  },
              }} 
              size='small'
              onClick={handleProductionGroupsCash}
            />
            <Chip
              variant="outlined"
              label={
                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                    <b>Print Application Form</b>
                </Typography>
              }
              sx={{
                  boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)',
                  minWidth: 0,
                  m:1,
                  backgroundColor:'brown',
                  color:'#fff',
                  '&:hover': {
                    boxShadow: '0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)',
                    backgroundColor:'#white',
                    color: '#000'
                  },
              }} 
              size='small'
              onClick={applicationForms}
            />
            </Grid>

            <Grid item xs={12} md={12}>
            {
                  groups_cash[0]?
                  <Box sx={{ display:'flex', marginBottom:1, flexWrap:'wrap', maxWidth: '100%', overflowX: 'auto', '&::-webkit-scrollbar': {
                      height: '5px',
                    },
                    '&::-webkit-scrollbar-track': {
                        background: '#f1f1f1',
                    },
                    '&::-webkit-scrollbar-thumb': {
                        background: '#888',
                        borderRadius: '10px',
                    },
                    '&::-webkit-scrollbar-thumb:hover': {
                        background: '#555',
                  }}}>
                      {
                        groups_cash.map((one) => (
                          <Card sx={{ m:1, width:450, borderRadius:7, boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)'}}>
                            <CardHeader
                                title={<Typography variant='h5' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>{one?.group_name}</b></Typography>}
                            />
                            <CardContent>
                            <Box sx={{ display: 'block', justifyContent:'space-between' }}>
                              <div>{renderTitle('Established Date', new Date(one?.date_created))}</div>
                              <div><Typography sx={{ m:'5px' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Account: {one?.account_name}</b></Typography></div>
                              <div><Typography sx={{ m:'5px' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Total loan: {currencyFormat.format(one?.group_total_cost)}</b></Typography></div>
                              <div style={{ margin:'10px' }}>
                                <Chip
                                    variant="contained"
                                    onDelete={doNothing}
                                    deleteIcon={one?.approved === 'Yes'?<CheckCircleIcon />: null}
                                    onClick={() => groupStat('approve', one.id ,'cash', one.group_total_cost)}
                                    label={<Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Approved</b></Typography>}
                                    sx={{
                                      color:'#000',
                                      backgroundColor: "#f5f3f4",
                                      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)',
                                      '&:hover': {
                                        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)',
                                        backgroundColor:'#bc6c25',
                                        color:'#fff',
                                      },
                                    }} 
                                    size='small'
                                />
                              </div>
                              <div style={{ margin:'10px' }}>
                                <Chip
                                    variant="contained"
                                    onDelete={doNothing}
                                    deleteIcon={one?.signed === 'Yes'?<CheckCircleIcon />: null}
                                    onClick={() => groupStat('signed', one.id ,'cash', one.group_total_cost)}
                                    label={<Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Signed</b></Typography>}
                                    sx={{
                                      color:'#000',
                                      backgroundColor: "#f5f3f4",
                                      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)',
                                      '&:hover': {
                                        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)',
                                        backgroundColor:'#bc6c25',
                                        color:'#fff',
                                      },
                                    }} 
                                    size='small'
                                />
                              </div>
                              <div style={{ margin:'10px' }}>
                                <Chip
                                    variant="contained"
                                    onDelete={doNothing}
                                    deleteIcon={one?.disbursed === 'Yes'?<CheckCircleIcon />: null}
                                    // disabled={one?.disbursed === 'Yes'?true:false}
                                    onClick={() => groupStat('disbursed', one.id ,'cash', one.group_total_cost)}
                                    label={<Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Disbursed</b></Typography>}
                                    sx={{
                                      color:'#000',
                                      backgroundColor: "#f5f3f4",
                                      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)',
                                      '&:hover': {
                                        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)',
                                        backgroundColor:'#bc6c25',
                                        color:'#fff',
                                      },
                                    }} 
                                    size='small'
                                />
                              </div>
                            </Box>
                            </CardContent>
                            <CardActions>
                              <div>
                                <Chip
                                    variant="contained"
                                    onClick={() => viewGroup(one, 'cash')}
                                    label={<Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Loan Contract And Disburesment Form</b></Typography>}
                                    sx={{
                                      color:'#fff',
                                      backgroundColor: "#eb5e28",
                                      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)',
                                      minWidth: 0,
                                      '&:hover': {
                                        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)',
                                        backgroundColor:'#bc6c25',
                                        color:'#fff',
                                      },
                                    }} 
                                    size='small'
                                />
                              </div>
                              <div>
                                <Chip
                                    variant="contained"
                                    onClick={() => viewGroupUploads(one.id)}
                                    label={<Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Uploads</b></Typography>}
                                    sx={{
                                      color:'#fff',
                                      backgroundColor: "#eb5e28",
                                      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)',
                                      minWidth: 0,
                                      '&:hover': {
                                        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)',
                                        backgroundColor:'#bc6c25',
                                        color:'#fff',
                                      },
                                    }} 
                                    size='small'
                                />
                              </div>
                            </CardActions>
                        </Card>
                        ))
                      }
                    </Box>
                  :
                  <Box sx={{ m:'auto' }}>
                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" sx={{ mr: 'auto' }}><b>No Group Loans Established</b></Typography>
                  </Box>
                }
            </Grid>

            {
              form_group_cash?
              <Grid item xs={12} md={12}>
                <Grid container spacing={2}>

                  <Grid item xs={12} md={12}>
                    <Box 
                      sx={{ 
                          display:'flex',
                          overflowX: 'auto', 
                          marginTop:'5px',
                          maxWidth: 1500, 
                          '&::-webkit-scrollbar': {
                            height: '5px',
                          },
                          '&::-webkit-scrollbar-track': {
                              background: '#f1f1f1',
                          },
                          '&::-webkit-scrollbar-thumb': {
                              background: '#888',
                              borderRadius: '10px',
                          },
                          '&::-webkit-scrollbar-thumb:hover': {
                              background: '#555',
                          }
                      }}
                    >
                      {
                        group_data_cash[0]?
                        group_data_cash?.map((account) => (
                          <Chip
                            size='small'
                            label={<Typography variant='subtitle' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>{account.loan_account}</b></Typography>}
                            sx={{
                              borderRadius:2,
                              m:1,
                              boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)',
                              backgroundColor:'#2b2d42',
                              color:'#fff',
                              '&:hover': {
                                boxShadow: '0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)',
                                backgroundColor:'#14213d',
                              },
                            }} 
                            onClick={() => handleDisplayAccount(account)} 
                          />
                        ))
                        :null
                      }
                    </Box>
                  </Grid>

                  {
                    account_details?
                    <Grid item xs={12} md={12}>
                      <Typography variant='subtitle' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>{account_account}</b></Typography>
                      <Chip
                        size='small'
                        label={<Typography variant='subtitle' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Build Group</b></Typography>}
                        sx={{
                          borderRadius:2,
                          m:1,
                          boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)',
                          backgroundColor:'#2b2d42',
                          color:'#fff',
                          '&:hover': {
                            boxShadow: '0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)',
                            backgroundColor:'#14213d',
                          },
                        }}
                        disabled={added_trs[0]? false: true}
                        onClick={() => buildGroup('cash')} 
                      />
                      <List 
                        sx={{ 
                          maxHeight: "70vh", 
                          overflow:'auto',
                          '&::-webkit-scrollbar': {
                            width: '5px',
                            height: '4px'
                          },
                          '&::-webkit-scrollbar-track': {
                              background: '#f1f1f1',
                          },
                          '&::-webkit-scrollbar-thumb': {
                              background: '#888',
                              borderRadius: '10px',
                          },
                          '&::-webkit-scrollbar-thumb:hover': {
                              background: '#555',
                          } 
                        }}
                        >
                          {
                            account_details?.members.map((member) => (
                              <>
                                <ListItem
                                  sx={{ backgroundColor:'#dee2e6' ,borderRadius:5, m:2 }}
                                  alignItems="flex-start"
                                  secondaryAction={<>
                                  {
                                    member.in_it?
                                    <Tooltip title={
                                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                        Member already registered in group
                                      </Typography>
                                    }
                                >
                                    <Chip
                                    size='small'
                                    label={<Typography variant='subtitle' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                          {
                                            member.stat === "account"? added_trs.findIndex(item => item.MemAcId === member.member_account_id) !== -1 ?
                                            <b>Remove</b> :
                                            <b>Add to group</b>
                                            :member.stat === "no_account"?
                                            <b>Activate account</b>
                                            :member.stat === "no_transaction"?
                                            <b>Make Request</b>
                                            :null
                                          }
                                        </Typography>
                                      }
                                    sx={{
                                      m:1,
                                      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)',
                                      backgroundColor:'#eb5e28',
                                      color:'#fff',
                                      '&:hover': {
                                        boxShadow: '0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)',
                                        backgroundColor:'#bc6c25',
                                      },
                                    }}
                                  />
                                  </Tooltip>
                                  :
                                  <Chip
                                    size='small'
                                    label={<Typography variant='subtitle' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                          {
                                            member.stat === "account"? added_trs.findIndex(item => item.MemAcId === member.member_account_id) !== -1 ?
                                            <b>Remove</b> :
                                            <b>Add to group</b>
                                            :member.stat === "no_account"?
                                            <b>Activate account</b>
                                            :member.stat === "no_transaction"?
                                            <b>Make Request</b>
                                            :null
                                          }
                                        </Typography>
                                      }
                                    sx={{
                                      m:1,
                                      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)',
                                      backgroundColor:'#eb5e28',
                                      color:'#fff',
                                      '&:hover': {
                                        boxShadow: '0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)',
                                        backgroundColor:'#bc6c25',
                                      },
                                    }} 
                                    onClick={() =>{
                                      if(member.stat === "account"){
                                        const existingIndex = added_trs.findIndex(item => item.MemAcId === member.member_account_id);
                                        if (existingIndex !== -1) {
                                          const updated_trs = [...added_trs];
                                          updated_trs.splice(existingIndex, 1);
                                          setTypes("cash")
                                          setAdded_trs(updated_trs);
                                        } else {
                                          setAdded_trs(prevState => [...prevState, {'MemAcId': member.member_account_id}]);
                                        }
                                      }else if(member.stat === "no_account"){
                                        setTypes("cash")
                                        activateAccount(member.passbook_id, member.member_id, account_details?.loan_account_id)
                                      }else if(member.stat === "no_transaction"){
                                        openMakeRequestCash(member.passbook_id, member.member_id, member.member_account_id, account_details?.loan_account_id)
                                      }
                                    }}
                                  />
                                }
                                 </>
                                }
                              >
                                <ListItemAvatar>
                                  <Avatar sx={{ width: 55, height: 55, mr:1 }} alt={member.member_name} src={pic(member.member_image)} />
                                </ListItemAvatar>
                                <ListItemText
                                  primary={member.member_name}
                                  secondary={
                                    <Box sx={{ display:'block' }}>
                                      <div>
                                        <Typography
                                          sx={{ display: 'inline' }}
                                          component="span"
                                          variant="body2"
                                          color="text.primary"
                                          fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                        >
                                          <b>Contact: {member.member_phone}</b>
                                        </Typography>
                                      </div>
                                      <div>
                                      <Typography
                                        sx={{ display: 'inline' }}
                                        component="span"
                                        variant="body2"
                                        color="text.primary"
                                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                      >
                                        <b>Passbook: {member.psb}</b>
                                      </Typography>
                                    </div>
                                    {
                                      member.stat === "account"?
                                      <>
                                          <div>
                                        <Typography
                                          sx={{ display: 'inline' }}
                                          component="span"
                                          variant="body2"
                                          color="text.primary"
                                          fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                        >
                                          <b>Loan Requested: {member?.amount?currencyFormat.format(member?.amount):0}</b>
                                        </Typography>
                                      </div>
                                      <div>
                                        <Typography
                                          sx={{ display: 'inline' }}
                                          component="span"
                                          variant="body2"
                                          color="text.primary"
                                          fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                        >
                                          <b>Amount Recommended: {member?.recommended_amount?currencyFormat.format(member?.recommended_amount):"No recommendations"}</b>
                                          <Chip  
                                            size='small'
                                            label='Recommend'
                                            disabled={member.in_it?true:false}
                                            onClick={() => recommend(member?.trs_id, member?.amount, member?.recommended_amount, member?.message)}
                                            sx={{
                                              ml:3,
                                              boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)',
                                              backgroundColor:'gray',
                                              color:'#fff',
                                              '&:hover': {
                                                boxShadow: '0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)',
                                                backgroundColor:'#bc6c25',
                                              },
                                            }}
                                          />
                                        </Typography>
                                      </div>
                                      <div>
                                        <Typography
                                          sx={{ display: 'inline' }}
                                          component="span"
                                          variant="body2"
                                          color="text.primary"
                                          fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                        >
                                          <b>Recommended message: {member?.message?member?.message:"No message"}</b>
                                        </Typography>
                                      </div>
                                      </>
                                      :null
                                    }
                                    
                                    </Box>
                                  }
                                    >
                                    
                                    </ListItemText>
                              </ListItem>
                              </>
                            ))
                          }
                        </List>
                    </Grid>
                    :null
                  }

                </Grid>
              </Grid>
              :null
            }

          </Grid>
        </AccordionDetails>
      </Accordion>

      {
         permissions && permissions.approve_loan_requests === true?
      <Box
          m="40px 0 0 0"
          height="75vh"
          paddingBottom="85px"
      >
          <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" variant='h3' sx={{ marginBottom:'10px', textAlign:'center' }}><b>Savings Group's Requested Loans</b></Typography>
        <Typography>Filter Date</Typography>
            <div style={{ display:'flex' }}>
              <TextField
                type='date'
                size="small"
                required
                variant="outlined"
                helperText="From"
                name="start_date"
                onChange={(e) => setStart_date(e.target.value)}
                value={start_date}
                sx={{ mr:1 }}
              />

              <TextField
                type='date'
                size="small"
                required
                variant="outlined"
                helperText="To"
                name="end_date"
                onChange={(e) => setEnd_date(e.target.value)}
                value={end_date}
                sx={{ mr:1 }}
              />

              <IconButton onClick={AllRequestedLoansFiltered}><FilterAltOutlinedIcon /></IconButton>
              <IconButton onClick={AllRequestedLoans}><CancelIcon /></IconButton>
              
            </div>
      <DataGrid
        rows={requestedLoans}
        columns={Rcolumns}
        checkboxSelection
        getRowId={(row) => row.Transaction_id}
        sortingOrder={['desc', 'asc']}
          sortModel={[
          {
              field: 'Transaction_id',
              sort: 'desc',
          },
          ]}
        slots={{ toolbar: GridToolbar, footer: () => CustomFooterRow('reg') }}
        initialState={{
          columns: {
            columnVisibilityModel: {
              Transaction_id: false,
              Member_id: false,
              Recommended_Amount: false
            },
          },
        }}
      />
      </Box>
      :
      null
      }
      <Box
          m="40px 0 0 0"
          height="75vh"
          paddingBottom="45px"
      >
          <Typography variant='h3' sx={{ marginBottom:'10px', textAlign:'center' }}><b>Savings Group's Approved Loans</b></Typography>
        <Typography >Filter Date</Typography>
            <div style={{ display:'flex' }}>
              <TextField
                type='date'
                size="small"
                required
                variant="outlined"
                helperText="From"
                name="start_date_apr"
                onChange={(e) => setStart_date_apr(e.target.value)}
                value={start_date_apr}
                sx={{ mr:1 }}
              />

              <TextField
                type='date'
                size="small"
                required
                variant="outlined"
                helperText="To"
                name="end_date_apr"
                onChange={(e) => setEnd_date_apr(e.target.value)}
                value={end_date_apr}
                sx={{ mr:1 }}
              />

              <IconButton onClick={AllApprovedLoansFiltered}><FilterAltOutlinedIcon /></IconButton>
              <IconButton onClick={AllApprovedLoans}><CancelIcon /></IconButton>
              
            </div>
      <DataGrid
          rows={approvedLoans}
          columns={columns}
          checkboxSelection
          getRowId={(row) => row.Transaction_id}
          sortingOrder={['desc', 'asc']}
          sortModel={[
          {
              field: 'Transaction_id',
              sort: 'desc',
          },
          ]}
          slots={{ toolbar: GridToolbar, footer: () => CustomFooterRow('apr') }}
          initialState={{
            columns: {
              columnVisibilityModel: {
                Transaction_id: false,
                Member_id: false,
              },
            },
          }}
      />
  {opennn}
<Typography variant='h3' sx={{ marginBottom:'10px', textAlign:'center' }}><b>Savings Group's Disbursed Loans</b></Typography>
  <Typography >Filter Date</Typography>
            <div style={{ display:'flex' }}>
              <TextField
                type='date'
                size="small"
                required
                variant="outlined"
                helperText="From"
                name="start_date_dis"
                onChange={(e) => setStart_date_dis(e.target.value)}
                value={start_date_dis}
                sx={{ mr:1 }}
              />

              <TextField
                type='date'
                size="small"
                required
                variant="outlined"
                helperText="To"
                name="end_date_dis"
                onChange={(e) => setEnd_date_dis(e.target.value)}
                value={end_date_dis}
                sx={{ mr:1 }}
              />

              <IconButton onClick={AllDisbursedLoansFiltered}><FilterAltOutlinedIcon /></IconButton>
              <IconButton onClick={AllDisbursedLoans}><CancelIcon /></IconButton>
              
            </div>
      <DataGrid
          rows={disbusedLoans}
          columns={DisColumns}
          checkboxSelection
          getRowId={(row) => row.Transaction_id}
          sortingOrder={['desc', 'asc']}
          sortModel={[
          {
              field: 'Transaction_id',
              sort: 'desc',
          },
          ]}
          slots={{ toolbar: GridToolbar, footer: () => CustomFooterRow('dis') }}
          initialState={{
            columns: {
              columnVisibilityModel: {
                Transaction_id: false,
                Member_id: false,
                type: false,
                interest_amount: false,
                period: false
              },
            },
          }}
      />
      </Box>



                    <Dialog
                      open={open_dialog}
                      fullWidth={true}
                      maxWidth='md'
                      onClose={handleCloseAppro}
                    >
                        <form onSubmit={approve_it_wai}>
                      <DialogTitle>Recommendation and Approval</DialogTitle>
                      <DialogContent>
                        {
                          apr_info.Member_Details ?
                        <Grid container sx={{ minHeight:442 }}>
                            <Grid item xs={12} md={12}>
                              <div style={{ display:'flex' }}>
                              <Avatar
                                variant="rounded"
                                sx={{ bgcolor: '#540b0e' }}
                              >{getInitials(apr_info.Member_Details.firstname, apr_info.Member_Details.lastname)}</Avatar>
                              <Typography
                                sx={{ml:1}}
                              >{`${apr_info.Member_Details.firstname} ${apr_info.Member_Details.lastname}`}
                              </Typography>
                              </div>
                              </Grid>
                              <Grid item xs={12} md={6}>
                              <div style={{ display: 'flex' }}>
                                  <Typography sx={{ fontWeight: '700', color:'#370617', mr:2 }}>Loan Status:</Typography>
                                     <Typography>{apr_info.Member_Details.status}</Typography>
                                  </div>
                                     <Typography>Contact: <span style={{ marginLeft:5 }}>{apr_info.Member_Details.phone}</span></Typography>
                                     {
                                        apr_info.associations.map((item) => (
                                          
                                              <Chip
                                                  key={item.association_name}
                                                  label={`${item.association_name}`}
                                                  style={{ margin: '4px' }}
                                                  variant='outlined'
                                                  sx={{ backgroundColor: "#fdf0d5", color: '#000814' }}
                                              />
                                        ))
                                     }
                                    <Typography 
                                      sx={{ fontWeight: '700', color:'#240046' }}
                                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                    >
                                      <b>Net Worth</b>
                                    </Typography>

                                  <div style={{ display: 'flex' }}>
                                  <Typography
                                  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                   sx={{ fontWeight: '700', color:'#370617', mr:2 }}><b>Total Savings Account Balance:</b></Typography>
                                     <Typography><b>{currencyFormat.format(apr_info.Savings_Account_Balance)}</b></Typography>
                                  </div>

                                  <div style={{ display: 'flex' }}>
                                  <Typography
                                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                    sx={{ fontWeight: '700', color:'#370617', mr:2 }}><b>Total Loans Account Balance:</b></Typography>
                                     <Typography><b>{currencyFormat.format(apr_info.Loans_Account_Balance)}</b></Typography>
                                  </div>

                                  <div style={{ display: 'flex' }}>
                                  <Typography 
                                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                    sx={{ fontWeight: '700', color:'#370617', mr:2 }}><b>Total Share Account Balance:</b></Typography>
                                     <Typography><b>{currencyFormat.format(apr_info.Shares_Account_Balance)}</b></Typography>
                                  </div>

                                  <div style={{ display: 'flex' }}>
                                  <Typography
                                     fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                     sx={{ fontWeight: '700', color:'#370617', mr:2 }}><b>Total Commodities Cash Values:</b></Typography>
                                     <Typography><b>{currencyFormat.format(apr_info.Commodities_Account_Balance)}</b></Typography>
                                  </div>

                                  <div style={{ display: 'flex' }}>
                                  <Typography 
                                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                    sx={{ fontWeight: '700', color:'#370617', mr:2 }}><b>Total Worth:</b></Typography>
                                     <Typography variant='h5'><b>{currencyFormat.format(apr_info.Shares_Account_Balance + apr_info.Savings_Account_Balance + apr_info.Loans_Account_Balance + apr_info.Commodities_Account_Balance)}</b></Typography>
                                  </div>
                                </Grid>

                                <Grid item xs={12} md={6}>
                                <Typography 
                                  sx={{ fontWeight: '700', color:'#240046', mb:2 }}
                                  variant='h5'
                                  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                  ><b>Current Savings Group Detials</b></Typography>
                                  
                                  <div style={{ display: 'flex' }}>
                                  <Typography
                                    sx={{ fontWeight: '700', color:'#370617', mr:2 }}
                                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" 
                                  ><b>Total Savings Account Balance:</b></Typography>
                                     <Typography><b>{currencyFormat.format(props.savingsTotal)}</b></Typography>
                                  </div>

                                  <div style={{ display: 'flex' }}>
                                  <Typography
                                    sx={{ fontWeight: '700', color:'#370617', mr:2 }}
                                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" 
                                  ><b>Total Loans Account Balance:</b></Typography>
                                     <Typography><b>{currencyFormat.format(props.loansTotal)}</b></Typography>
                                  </div>

                                  <div style={{ display: 'flex' }}>
                                  <Typography
                                    sx={{ fontWeight: '700', color:'#370617', mr:2 }}
                                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" 
                                  ><b>Total Share Account Balance:</b></Typography>
                                     <Typography><b>{currencyFormat.format(props.sharesTotal)}</b></Typography>
                                  </div>

                                  <div style={{ display: 'flex' }}>
                                  <Typography
                                    sx={{ fontWeight: '700', color:'#370617', mr:2 }}
                                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" 
                                  ><b>Total Commodity Value:</b></Typography>
                                     <Typography><b>{currencyFormat.format(props.commodityTotal)}</b></Typography>
                                  </div>

                                  <div style={{ display: 'flex' }}>
                                  <Typography
                                    sx={{ fontWeight: '700', color:'#370617', mr:2 }}
                                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" 
                                  ><b>Total Worth:</b></Typography>
                                     <Typography variant='h5'><b>{currencyFormat.format(props.associationWorth)}</b></Typography>
                                  </div>
                                </Grid>
                            <Grid item xs={12} md={12}>
                              <Box sx={{ display: 'block' }}>
                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                  <b>Requested Amount: {currencyFormat.format(apr_info.Member_Details.amount)}</b>
                                </Typography>
                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                  <b>Recommended Amount: {currencyFormat.format(apr_info.Member_Details.recommended_amount)}</b>
                                </Typography>
                              </Box>
                            </Grid>
                        </Grid>
                        :
                        <Box sx={{ width: '100%' }}>
                          <CircularProgress />
                        </Box>
                        }
                      </DialogContent>
                        
                      <DialogContent>
                      <div style={{ margin:'10px' }}>
                        <TextField
                          size='small'
                          value={recommended_amount}
                          type='number'
                          name='recommended_amount'
                          onChange={e => setRecommended_amount(e.target.value)}
                          label='Recommend amount (Optional)'
                        />
                      </div>
                      
                      <TextField
                        size='small'
                        value={approval_message}
                        multiline
                        fullWidth
                        onChange={e => setApproval_message(e.target.value)}
                        name='approval_message'
                        rows={4}
                        label='Approval Message'
                      />
                      </DialogContent>
                      <DialogActions sx={{ display: 'flex', justifyContent:'space-between' }}>
                        <Button onClick={handleCloseAppro} variant='contained' color='error'>Cancel</Button>
                        {
                          loading === false?
                          <Fab component='button' type='submit' color="success" size='medium' aria-label="add">
                            <SendIcon/>
                          </Fab>
                          :
                          <Box>
                            <CircularProgress color="success" />
                          </Box>
                        }
                        
                      </DialogActions>
                      </form>
                    </Dialog>




      <Dialog
          open={open}
          fullWidth={true}
          maxWidth='md'
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
      >
          <DialogTitle id="alert-dialog-title">
            Disburse Loan
          </DialogTitle>
          <DialogContent>
          {
            typese === "cash"?
            apr_info.Member_Details?
          <Grid container>
              <Grid item xs={12} md={12}>
                <div style={{ display:'flex' }}>
                <Avatar
                  variant="rounded"
                  sx={{ bgcolor: '#540b0e' }}
                >{getInitials(apr_info.Member_Details.firstname, apr_info.Member_Details.lastname)}</Avatar>
                <Typography
                  sx={{ml:1}}
                >{`${apr_info.Member_Details.firstname} ${apr_info.Member_Details.lastname}`}
                </Typography>
                </div>
                </Grid>
                <Grid item xs={12} md={12}>
                <div style={{ display: 'flex' }}>
                <Typography sx={{ fontWeight: '700', color:'#370617', mr:2 }}>Loan Status:</Typography>
                    <Typography>{apr_info.Member_Details.status}</Typography>
                </div>
                        <Typography>Contact: <span style={{ marginLeft:5 }}>{apr_info.Member_Details.phone}</span></Typography>
                        <Typography sx={{ fontWeight: '700', color:'#370617' }}>Savings Groups Joined:</Typography>
                        {
                          apr_info.associations.map((item) => (
                            
                                <Chip
                                    key={item.association_name}
                                    label={`${item.association_name}`}
                                    style={{ margin: '4px' }}
                                    variant='outlined'
                                    sx={{ backgroundColor: "#fdf0d5", color: '#000814' }}
                                />
                          ))
                        }
                        <Typography 
                                      sx={{ fontWeight: '700', color:'#240046' }}
                                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                    >
                                      <b>Net Worth</b>
                                    </Typography>

                                  <div style={{ display: 'flex' }}>
                                  <Typography
                                  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                   sx={{ fontWeight: '700', color:'#370617', mr:2 }}><b>Total Savings Account Balance:</b></Typography>
                                     <Typography><b>{currencyFormat.format(apr_info.Savings_Account_Balance)}</b></Typography>
                                  </div>

                                  <div style={{ display: 'flex' }}>
                                  <Typography
                                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                    sx={{ fontWeight: '700', color:'#370617', mr:2 }}><b>Total Loans Account Balance:</b></Typography>
                                     <Typography><b>{currencyFormat.format(apr_info.Loans_Account_Balance)}</b></Typography>
                                  </div>

                                  <div style={{ display: 'flex' }}>
                                  <Typography 
                                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                    sx={{ fontWeight: '700', color:'#370617', mr:2 }}><b>Total Share Account Balance:</b></Typography>
                                     <Typography><b>{currencyFormat.format(apr_info.Shares_Account_Balance)}</b></Typography>
                                  </div>

                                  <div style={{ display: 'flex' }}>
                                  <Typography
                                     fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                     sx={{ fontWeight: '700', color:'#370617', mr:2 }}><b>Total Commodities Cash Values:</b></Typography>
                                     <Typography><b>{currencyFormat.format(apr_info.Commodities_Account_Balance)}</b></Typography>
                                  </div>

                                  <div style={{ display: 'flex' }}>
                                  <Typography 
                                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                    sx={{ fontWeight: '700', color:'#370617', mr:2 }}><b>Total Worth:</b></Typography>
                                     <Typography variant='h5'><b>{currencyFormat.format(apr_info.Shares_Account_Balance + apr_info.Savings_Account_Balance + apr_info.Loans_Account_Balance + apr_info.Commodities_Account_Balance)}</b></Typography>
                                  </div>
                                </Grid>

                                <Grid item xs={12} md={6}>
                                <Typography 
                                  sx={{ fontWeight: '700', color:'#240046', mt:2 }}
                                  variant='h5'
                                  fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                  ><b>Current Savings Group Detials</b></Typography>
                                  
                                  <div style={{ display: 'flex' }}>
                                  <Typography
                                    sx={{ fontWeight: '700', color:'#370617', mr:2 }}
                                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" 
                                  ><b>Total Savings Account Balance:</b></Typography>
                                     <Typography><b>{currencyFormat.format(props.savingsTotal)}</b></Typography>
                                  </div>

                                  <div style={{ display: 'flex' }}>
                                  <Typography
                                    sx={{ fontWeight: '700', color:'#370617', mr:2 }}
                                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" 
                                  ><b>Total Loans Account Balance:</b></Typography>
                                     <Typography><b>{currencyFormat.format(props.loansTotal)}</b></Typography>
                                  </div>

                                  <div style={{ display: 'flex' }}>
                                  <Typography
                                    sx={{ fontWeight: '700', color:'#370617', mr:2 }}
                                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" 
                                  ><b>Total Share Account Balance:</b></Typography>
                                     <Typography><b>{currencyFormat.format(props.sharesTotal)}</b></Typography>
                                  </div>

                                  <div style={{ display: 'flex' }}>
                                  <Typography
                                    sx={{ fontWeight: '700', color:'#370617', mr:2 }}
                                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" 
                                  ><b>Total Commodity Value:</b></Typography>
                                     <Typography><b>{currencyFormat.format(props.commodityTotal)}</b></Typography>
                                  </div>

                                  <div style={{ display: 'flex' }}>
                                  <Typography
                                    sx={{ fontWeight: '700', color:'#370617', mr:2 }}
                                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" 
                                  ><b>Total Worth:</b></Typography>
                                     <Typography variant='h5'><b>{currencyFormat.format(props.associationWorth)}</b></Typography>
                                  </div>
                    <DialogContent>
                      <TextField
                        size='small'
                        value={approval_message}
                        multiline
                        fullWidth
                        disabled
                        rows={4}
                        label='Approval Message'
                      />
                      </DialogContent>
                      <Button
                          size='small'
                          onClick={disapproved}
                          color='error'
                          variant='contained'
                          sx={{ mt:1, mr:1 }}
                      >
                          Disapprove
                      </Button>
                  </Grid>
              
          </Grid>
          :
          null
          :null
          }
          </DialogContent>

        <form onSubmit={handleClickApprove}>
          <DialogContent>
          <Box sx={{ m:2, display: 'block' }}>
            {
              typese === "cash"?
              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                <b>Total loan Amount: {currencyFormat.format(nowAmount)}</b>
              </Typography>
            :
            <>
              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                <b>Requested Amount: {currencyFormat.format(nowAmount)}</b>
              </Typography>
              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                <b>Recommended Amount: {currencyFormat.format(nowAmountat)}</b>
              </Typography>
              <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                <b>Approved Amount: {currencyFormat.format(nowAmountat || nowAmountat > 0? nowAmountat : nowAmount)}</b>
              </Typography>
            </>
            }
            
          </Box>
          <TextField
            required 
            margin="dense"
            name="repayment_starts"
            id="repayment_starts"
            helperText="Repayment Commencement date"
            variant="outlined"
            type="date"
            fullWidth
            size="small"
            value={repayment_starts}
            onChange={e => setRepayment_starts(e.target.value)}
          />
           <div sx={{ display:'flex' }}>
              <Button variant='outlined' sx={{ mr:2 }} size='small' color='success' onClick={()=>setRepaymentTimes("weeks")}>Repayment in Weeks</Button>                       
              <Button variant='outlined' size='small' color='success' onClick={()=>setRepaymentTimes("months")}>Repayment in Months</Button>
          </div>
          {
            repaymentTimes && repaymentTimes === "weeks"
            ?
            <> 
            <TextField
              required
              margin="dense"
              name="num_of_weeks_to_end_payment"
              id="num_of_weeks_to_end_payment"
              label="Number of week(s) for repayment"
              variant="outlined"
              type="number"
              fullWidth
              size="small"
              value={num_of_weeks_to_end_payment}
              onChange={e => setNum_of_weeks_to_end_payment(e.target.value)}
            />
            <TextField
              required
              margin="dense"
              name="interest_period"
              id="interest_period"
              label="Number of week(s) for interest"
              variant="outlined"
              type="number"
              fullWidth
              size="small"
              value={interest_period}
              onChange={e => setInterest_period(e.target.value)}
            />
            </>
            : repaymentTimes && repaymentTimes === "months"
            ?
            <>
              <TextField
                required
                margin="dense"
                name="num_of_weeks_to_end_payment"
                id="num_of_weeks_to_end_payment"
                label="Number of month(s) for repayment"
                variant="outlined"
                type="number"
                fullWidth
                size="small"
                value={num_of_weeks_to_end_payment}
                onChange={e => setNum_of_weeks_to_end_payment(e.target.value)}
            />
              <TextField
              required
              margin="dense"
              name="interest_period"
              id="interest_period"
              label="Number of month(s) for interest"
              variant="outlined"
              type="number"
              fullWidth
              size="small"
              value={interest_period}
              onChange={e => setInterest_period(e.target.value)}
            />
            </>
            : null
          }
          </DialogContent>
          <div style={{ display: 'flex' }}>
            <Typography sx={{ margin:'5px',color:'#003049' }} fontStyle='normal' variant="h6" fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Accounts</b></Typography> 
            <Switch
                checked={openn}
                onChange={() => setOpenn(event.target.checked)}
                sx={{color:'#001845'}}
                inputProps={{ 'aria-label': 'controlled' }}
              />
          </div>
          {
            openn? 
            <DialogContent>
          <Box>
              <Typography variant='h6' sx={{ textAlign: 'center', color:'darkblue', mb: 2, mt: 1 }}>Select society to display available bank accounts</Typography>
                        <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                            {
                                soc === 0?
                                society.map((item)=>(
                                    <Chip key={item.id} label={item.society} onClick={() => handleSocietyBanks(item.id)}  variant="outlined" color="success" style={{ margin: '4px'}} />
                                ))
                                : 
                                <Chip key={society.id} label={society.society} onClick={() => handleSocietyBanks(society.id)}  variant="outlined" color="success" style={{ margin: '4px'}} />
                            }
                        </div>

                        <Divider sx={{my:1}} variant="middle" />
                          <Chip
                            disabled={(nowAmountat? nowAmountat < accounts?.Main?.current_balance: nowAmount < accounts?.Main?.current_balance)? false:true}
                            label={`Main Wallet Account | ${currencyFormat.format(accounts?.Main?.current_balance)}`}
                            onClick={() => handleDisburseConfirmation('ecash', accounts?.Main?.id)}
                            variant="outlined"
                            color="success"
                            style={{ margin: "4px" }}
                          />
                          
                          <Divider sx={{my:1}} variant="middle">
                            <Typography
                              fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                            >
                              <b>Other Accounts</b>
                            </Typography>
                          </Divider>
                        {
                            accounts?.Accounts?.length > 0?
                            <Grid item xs={12} md={6}>
                                <Typography sx={{ textAlign: 'center', fontSize:20 }}>{nm}</Typography>
                                <Typography variant='h6' sx={{ textAlign: 'center', color:'darkblue', mb: 2, mt: 1 }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Select account to disburse funds from</b></Typography>
                                <Iteme>
                                    <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                                        {
                                            accounts?.Accounts?.map((item)=>(
                                                <Chip disabled={(nowAmountat? nowAmountat < item.current_balance: nowAmount < item.current_balance)? false:true} key={item.id} label={`${item.account_name} GHS${item.current_balance}`} onClick={() => handleDisburseConfirmation('bank', item.id)}  variant="outlined" color="success" style={{ margin: '4px'}} />
                                            ))
                                        }
                                    </div>
                                </Iteme>
                            </Grid>:
                            <Typography sx={{ margin:'5px',color:'#003049' }} fontStyle='normal' variant="subtitle" fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>No other accounts to display</b></Typography>  
                        }
                        {
                            transferDetails.Bank_Account_Name?
                            <Grid item xs={12} md={12} sx={{ m:1 }}>
                              <Iteme>
                                <Typography sx={{color:'black' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                    <b>Account: {transferDetails.Bank_Account_Name}</b>
                                </Typography>

                                <Typography sx={{color:'black' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                    <b>Receiver Name: {transferDetails.Funds_Reciever}</b>
                                </Typography>

                                <Typography sx={{color:'black' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                    <b>Reason for funding: {transferDetails.Reason_For_Funds}</b>
                                </Typography>

                                <Typography sx={{color:'black' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                    <b>Requested: {moment(transferDetails.Request_Date).fromNow()}</b>
                                </Typography>

                                <Typography sx={{color:'black' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                    <b>Receiver Role: {transferDetails.Reciever_Role}</b>
                                </Typography>

                                <Typography sx={{color:'black' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                    <b>Receiver Passbook: {transferDetails.Reciever_Passbook}</b>
                                </Typography>

                                <Typography sx={{color:'black' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                    <b>Amount to be Disbursed: {currencyFormat.format(transferDetails.Amount_Requesting)}</b>
                                </Typography>

                                <Typography sx={{color:'black' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                    <b>Current bank Balance: {currencyFormat.format(transferDetails.Current_Bank_Amount)}</b>
                                </Typography>

                                <Typography sx={{color:'black' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                    <b>Balance after disbursement: {currencyFormat.format(transferDetails.Amount_After_Disbursement)}</b>
                                </Typography>
                              </Iteme>
                            </Grid>
                            :null
                        }
              </Box>
          </DialogContent>
          : null
          }
          
          
          <DialogActions>
          <Button onClick={handleClose} startIcon={<Cancel />} variant="contained" color="error" size="small">Cancle</Button>
          <Button type='submit' size='small' autoFocus sx={{mr:1}} disabled={transferDetails.Bank_Account_Name?false:true} variant="contained" color="success" startIcon={<Send size='small'/>}>
              {
                loading?
                <CircularProgress />
                :
                "Disburse"
              }
          </Button>
          </DialogActions>
          </form>
      </Dialog>
      
      {/* cash request */}
      <Dialog open={req_modal_cash} onClose={closeMakeRequest}>
            <form onSubmit={formiko.handleSubmit}>
            <DialogTitle>Cash Loan Request</DialogTitle>
            <DialogContent>
            <DialogContentText>
                Loan Request
            </DialogContentText>
            
            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Min Amount: {currencyFormat.format(info[0]?.Min_amt)}</b></Typography>
            
            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">Max Amount: <b>{currencyFormat.format(info[0]?.Max_amt)}</b></Typography>
            <TextField
                margin="dense"
                id="Amount"
                name="Amount"
                label="Amount"
                onChange={formiko.handleChange}
                value={formiko.values.Amount}
                onBlur={formiko.handleBlur}
                error={formiko.touched.Amount && Boolean(formiko.errors.Amount)}
                helperText={formiko.touched.Amount && formiko.errors.Amount}
                type="number"
                fullWidth
                variant="outlined"
            />

            <TextField
                margin="dense"
                id="narration"
                name="narration"
                label="Narration (optional)"
                onChange={formiko.handleChange}
                type="text"
                value={formiko.values.narration}
                onBlur={formiko.handleBlur}
                error={formiko.touched.narration && Boolean(formiko.errors.narration)}
                helperText={formiko.touched.narration && formiko.errors.narration}
                fullWidth
                variant="outlined"
            />
            
            </DialogContent>
            <DialogActions>
            <Button onClick={closeMakeRequest}>Cancel</Button>
            <Button type='submit'>Request</Button>
            </DialogActions>
            </form>
        </Dialog>

      <Modal
        open={open_recommend}
        onClose={closeRecommend}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      > 
        <Box sx={style}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={12}>
              <Typography textAlign='center' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" variant='h5'>
                <b>Recommendations</b>
              </Typography>
            </Grid>

            <Grid item xs={12} md={12}>
              <Typography textAlign='center' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                <b>Member Current balances </b>
              </Typography>
              <Typography textAlign='center' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                <b>Requesting {currencyFormat.format(id_amount)}</b>
              </Typography>
              <Typography sx={{ m:'3px' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Savings amount: {currencyFormat.format(data_recommend?.savings_sum)}</b></Typography>
              <Divider  variant='middle'/>
              <Typography sx={{ m:'3px' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Shares amount: {currencyFormat.format(data_recommend?.shares_sum)}</b></Typography>
              <Divider variant='middle' />
              <Typography sx={{ m:'3px' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Commodity value: {currencyFormat.format(data_recommend?.commodities_sum)}</b></Typography>
              <Divider variant='middle' />
              <Typography sx={{ m:'3px' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Warehouse loan: {currencyFormat.format(data_recommend?.warehouse_loan)}</b></Typography>
              <Divider variant='middle' />
              <Typography sx={{ m:'3px' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Production loan: {currencyFormat.format(data_recommend?.production_loan)}</b></Typography>
              <Divider variant='middle' />
              <Typography sx={{ m:'3px' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Equipment loan: {currencyFormat.format(data_recommend?.equipment_loan)}</b></Typography>
              <Divider variant='middle' />
              <Typography sx={{ m:'3px' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Cash loan: {currencyFormat.format(data_recommend?.cash_loans)}</b></Typography>
              <Divider variant='middle' />
            </Grid>

            <Grid item xs={12} md={12}>
              <TextField 
                size="small"
                value={recco}
                name="recco"
                sx={{m:'auto'}}
                type="number"
                inputProps={{ step: 'any' }}
                placeholder='Recommend Amount here'
                onChange={(e) => setRecco(e.target.value)}
              />
            </Grid>

            <Grid item xs={12} md={12}>
              <TextField 
                size="small"
                fullWidth
                sx={{ m:'auto' }}
                value={recco_message}
                placeholder='type message here'
                name='recco_message'
                multiline
                row={4}
                onChange={(e) => setRecco_message(e.target.value)}
              />
            </Grid>
            <Grid item xs={12} md={12}>
              <Button 
                size='small' 
                variant='contained' 
                sx={{ 
                  m:1, 
                  backgroundColor:'#33415c', 
                  borderRadius:4,
                  boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)',
                  minWidth: 0,
                  '&:hover': {
                  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)',
                  backgroundColor:'#80ed99',
                  color:'#000'
                  }, 
                }} 
                onClick={closeRecommend}
              >
                Cancel
              </Button>
              <Button 
                size='small' 
                variant='contained' 
                sx={{ 
                  m:1, 
                  backgroundColor:'#33415c', 
                  borderRadius:4,
                  boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)',
                  minWidth: 0,
                  '&:hover': {
                  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)',
                  backgroundColor:'#80ed99',
                  color:'#000'
                  }, 
                }} 
                onClick={handleRecommend}
              >
                Save
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Modal>

      {/* modal */}
      <Modal
        open={req_modal}
        onClose={closeMakeRequest}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      > 
        <Box sx={style}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={12}>
              <Typography textAlign='center' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" variant='h5'>
                <b>Production Loan Setup</b>
              </Typography>
            </Grid>

            <Grid item x={12} md={12}>
              <Accordion sx={{ borderRadius:2, mb:2 }}>
                  <AccordionSummary
                      expandIcon={<ExpandMore />}
                      aria-controls="panel2a-content"
                      id="panel3a-header"
                      display='flex'
                  >
                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" sx={{ mr: 'auto' }}><b>What are we cultivating this season?</b></Typography>
                  </AccordionSummary>
                  <AccordionDetails>
                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Member's Crops</b></Typography>
                                <Box sx={{ 
                                    display:'flex', 
                                    flexWrap:'wrap' , 
                                    overflowY: 'auto', 
                                    maxHeight: 200, 
                                    '&::-webkit-scrollbar': {
                                        width: '3px',
                                    },
                                    '&::-webkit-scrollbar-track': {
                                        background: '#f1f1f1',
                                    },
                                    '&::-webkit-scrollbar-thumb': {
                                        background: '#888',
                                        borderRadius: '10px',
                                    },
                                    '&::-webkit-scrollbar-thumb:hover': {
                                        background: '#555',
                                    } 
                                }}
                                >
                          {
                              member_crops[0] ? member_crops.map((teo, index) => (
                              <>
                                  {
                                    teo.main_crop ? (
                                    <Tooltip key={index} title={'Main Crop'}>
                                        <Chip
                                            label={`${teo.commodity} | ${teo.land_size ? `${teo.land_size} acres` : "N/A"}`}
                                            onDelete={doNothing}
                                            onClick={() => openLoanProducts(teo.commodity, teo.id, teo.land_size)}
                                            deleteIcon={<CheckCircleIcon />}
                                            sx={{ m:'5px', borderRadius: 2, boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)', }}
                                        />
                                    </Tooltip>
                                    ) : (
                                    <Chip
                                        key={index}
                                        onClick={() => openLoanProducts(teo.commodity, teo.id, teo.land_size)}
                                        label={`${teo.commodity} | ${teo.land_size ? `${teo.land_size} acres` : "N/A"}`}
                                        sx={{ m:'5px', borderRadius: 2, boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)', }}
                                    />
                                    )
                                  }
                                </>
                              ))
                                  
                              :
                              <>
                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>not speified. Do so here</b></Typography>
                                <div>
                                  <Typography sx={{ m:1 }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                    <b style={{ marginRight:'5px' }}>Crops: </b>
                                    <Autocomplete
                                        disablePortal
                                        id="combo-box-demo"
                                        options={farm_crops}
                                        multiple
                                        sx={{ width: 250 }}
                                        getOptionLabel={(option) => option.commodity}
                                        isOptionEqualToValue={(option, value) => option.id === value.id}
                                        onChange={(event, value) => {
                                            if (value) {
                                                const selectedIds = value.map(option => {
                                                    const landSizeKey = `land_size_${option.id}`;
                                                    return { id: option.id, crop: option.commodity, [landSizeKey]: 0 };
                                                });
                                                formik.setFieldValue("crops", selectedIds)
                                            } else {
                                                formik.setFieldValue("crops", []);
                                            }
                                        }}
                                        renderInput={(params) => <TextField {...params} variant='standard' size="small" placeholder='update'/>}
                                    />
                                  </Typography>
                                </div>
                            
                            {
                                formik.values.crops.map((item) => (
                                    <div>
                                      <TextField 
                                        key={item.id}
                                        size="small"
                                        sx={{ m:1 }}
                                        value={item.land_size || null}
                                        name={`land_size_${item.id}`}
                                        label={`Acres used for ${item.crop}`}
                                        onChange={(event) => {
                                            const updatedCrops = formik.values.crops.map(crop => {
                                                if (crop.id === item.id) {
                                                const landSizeKey = `land_size_${crop.id}`;
                                                    return { ...crop, [landSizeKey]: event.target.value };
                                                }
                                                return crop;
                                            });
                                            formik.setFieldValue("crops", updatedCrops);
                                        }}
                                      />
                                    </div>
                                ))
                            }
                            {
                                permissions && permissions.update_member === true ?
                                <Button size='small' variant='contained' sx={{ m:1, backgroundColor:'#33415c', borderRadius:4,
                                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)',
                                    minWidth: 0,
                                    '&:hover': {
                                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)',
                                    backgroundColor:'#80ed99',
                                    color:'#000'
                                    }, }} onClick={formik.handleSubmit}>Save</Button>
                                :
                                null
                            }
                            </>
                          }
                          </Box>
                  </AccordionDetails>
              </Accordion>
            </Grid>

            <Grid item xs={12} md={12}>
                    {
                        hold_crop?
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={12}>
                                <Typography variant='h4' textAlign='center' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                    <b>Services and Inputs Available for {hold_crop}</b>
                                </Typography>
                                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                    <b>Your land size for {hold_crop}: {hold_acres? `${hold_acres} acres`: 'N/A'}</b>
                                </Typography>
                                <Typography
                                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                    variant='body2'
                                >
                                    <b>Acres using: {slider_value}</b>
                                    </Typography>

                                    <PrettoSlider
                                        valueLabelDisplay="auto"
                                        aria-label="pretto slider"
                                        value={slider_value}
                                        onChange={changeSliderValue}
                                        step={1}
                                        size="small"
                                        max={hold_acres?hold_acres:100}
                                        marks
                                        sx={{ mb:2 }}
                                    />
                            </Grid>
                            <Grid item xs={12} md={6}>
                                <Typography variant='h5' textAlign='center' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                    <b>Subscribe to Services</b>
                                </Typography>
                                <Box sx={{ mb:1 ,maxHeight: 540, overflowY: 'auto', '&::-webkit-scrollbar': {
                                        width: '7px',
                                    },
                                    '&::-webkit-scrollbar-track': {
                                        background: '#f1f1f1',
                                    },
                                    '&::-webkit-scrollbar-thumb': {
                                        background: '#888',
                                        borderRadius: '10px',
                                    },
                                    '&::-webkit-scrollbar-thumb:hover': {
                                        background: '#555',
                                }}}>
                                    {
                                    subscribed_s.map((service) => (
                                        <ItemCard>
                                            <Typography sx={{ color:'#000', textAlign:'center' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                <b>{service.service}</b> 
                                            </Typography>
                                            <Typography sx={{ color:'#000', textAlign:'left' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                <b>Cost: {currencyFormat.format(service.service_price_per_acre)} per acre</b> 
                                            </Typography>
                                            <Typography sx={{ color:'#000', textAlign:'left' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                <b>Interest/anum: {service.interest_percentage_rate_anum}% </b> 
                                            </Typography> 

                                            <Accordion 
                                                sx={{ borderRadius:2, mb:2 }}
                                            >
                                                <AccordionSummary
                                                    expandIcon={<ExpandMore />}
                                                    aria-controls="panel2a-content"
                                                    id="panel3a-header"
                                                    display='flex'
                                                >
                                                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Private interest?</b></Typography>
                                                </AccordionSummary>
                                                <AccordionDetails>
                                                    <FormControl>
                                                        <FormLabel id="demo-row-radio-buttons-group-label">Type</FormLabel>
                                                        <RadioGroup
                                                            row
                                                            aria-labelledby="demo-row-radio-buttons-group-label"
                                                            name='interest_type'
                                                            value={subscribed_s.find(item => item.product_id === service.product_id)?.interest_type || ''}
                                                            onChange={(e) => {
                                                                const value = e.target.value;
                                                                const updatedSubscribed_s = subscribed_s.map(item => {
                                                                    if (item.product_id === service.product_id) {
                                                                        return {
                                                                            ...item,
                                                                            interest_type: value
                                                                        };
                                                                    }
                                                                    return item;
                                                                });
                                                                setSubscribed_s(updatedSubscribed_s);
                                                            }}
                                                        >
                                                            <FormControlLabel value="flat_rate" control={<Radio />} label="Fixed Amount" />
                                                            <FormControlLabel value="percentage_rate" control={<Radio />} label="Percentage Rate" />
                                                            <FormControlLabel value="" control={<Radio />} label="Default" />
                                                        </RadioGroup>
                                                    </FormControl>
                                                    {
                                                        subscribed_s.find(item => item.product_id === service.product_id)?.interest_type === 'flat_rate'?(
                                                            <TextField
                                                                size='small'
                                                                type='number'
                                                                variant='standard'
                                                                label='Type here'
                                                                inputProps={{ step: 'any' }}
                                                                name='private_interest'
                                                                value={subscribed_s.find(item => item.product_id === service.product_id)?.private_interest || null}
                                                                onChange={(e) => {
                                                                    const value = e.target.value;
                                                                    const updatedSubscribed_s = subscribed_s.map(item => {
                                                                        if (item.product_id === service.product_id) {
                                                                            return {
                                                                                ...item,
                                                                                private_interest: value
                                                                            };
                                                                        }
                                                                        return item;
                                                                    });
                                                                    setSubscribed_s(updatedSubscribed_s);
                                                                }}
                                                            />
                                                        ): subscribed_s.find(item => item.product_id === service.product_id)?.interest_type === 'percentage_rate'?(
                                                            <>
                                                            <TextField
                                                                size='small'
                                                                type='number'
                                                                variant='standard'
                                                                label='Type here (%)'
                                                                inputProps={{ step: 'any' }}
                                                                name='private_interest'
                                                                value={subscribed_s.find(item => item.product_id === service.product_id)?.private_interest || null}
                                                                onChange={(e) => {
                                                                    const value = e.target.value;
                                                                    const updatedSubscribed_s = subscribed_s.map(item => {
                                                                        if (item.product_id === service.product_id) {
                                                                            return {
                                                                                ...item,
                                                                                private_interest: value
                                                                            };
                                                                        }
                                                                        return item;
                                                                    });
                                                                    setSubscribed_s(updatedSubscribed_s);
                                                                }}
                                                            />

                                                            <TextField
                                                                size='small'
                                                                type='number'
                                                                variant='standard'
                                                                label='Number of months'
                                                                name='interest_months'
                                                                value={subscribed_s.find(item => item.product_id === service.product_id)?.interest_months || null}
                                                                onChange={(e) => {
                                                                    const value = e.target.value;
                                                                    const updatedSubscribed_s = subscribed_s.map(item => {
                                                                        if (item.product_id === service.product_id) {
                                                                            return {
                                                                                ...item,
                                                                                interest_months: value
                                                                            };
                                                                        }
                                                                        return item;
                                                                    });
                                                                    setSubscribed_s(updatedSubscribed_s);
                                                                }}
                                                            />
                                                            
                                                            </>
                                                        ):null
                                                    }
                                                </AccordionDetails>
                                            </Accordion>

                                            {/* <Button sx={{ m:1, backgroundColor:'#eb5e28', borderRadius:4 }} size="small"  variant="contained">
                                                Private interest
                                            </Button> */}
                                            <Button 
                                                sx={{ 
                                                    m:1, 
                                                    backgroundColor: subscribed_s.find(item => item.product_id === service.product_id)?.subscribe === true? '#bc6c25': '#eb5e28' , 
                                                    borderRadius:4 
                                                }} 
                                                size="small"  
                                                variant="contained"
                                                onClick={() => {
                                                    const updatedSubscribed_s = subscribed_s.map(one => {
                                                        if (one.product_id === service.product_id) {
                                                            return {
                                                                ...one,
                                                                subscribe: !one.subscribe
                                                            };
                                                        }
                                                        return one;
                                                    });
                                                    setSubscribed_s(updatedSubscribed_s);
                                                }}
                                            >
                                                {
                                                    subscribed_s.find(item => item.product_id === service.product_id)?.subscribe === true?
                                                    'Unsubscribe'
                                                    :
                                                    'Subscribe'
                                                }
                                                
                                            </Button>
                                            
                                        </ItemCard>
                                    ))
                                }
                                </Box>
                                
                            </Grid>

                            {/* Inputs */}
                            <Grid item xs={12} md={6}>
                                <Typography variant='h5' textAlign='center' fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                    <b>Subscribe for Farm Inputs</b>
                                </Typography>
                                <Box sx={{ mb:1 ,maxHeight: 540, overflowY: 'auto', '&::-webkit-scrollbar': {
                                        width: '7px',
                                    },
                                    '&::-webkit-scrollbar-track': {
                                        background: '#f1f1f1',
                                    },
                                    '&::-webkit-scrollbar-thumb': {
                                        background: '#888',
                                        borderRadius: '10px',
                                    },
                                    '&::-webkit-scrollbar-thumb:hover': {
                                        background: '#555',
                                }}}>
                                    {
                                    subscribed_i.map((input) => (
                                        <ItemCardI>
                                            <Typography sx={{ color:'#000', textAlign:'center' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                <b>{input.input}</b> 
                                            </Typography>
                                            <Typography sx={{ color:'#000', textAlign:'left' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                <b>Cost: {currencyFormat.format(input.input_price_per_acre)} per acre</b> 
                                            </Typography>
                                            <Typography sx={{ color:'#000', textAlign:'left' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                <b>Company: {input.company}</b> 
                                            </Typography>
                                            <Typography sx={{ color:'#000', textAlign:'left' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                <b>Quantity per acre: {input.quantity} (kg/g/liters/bags/...)</b> 
                                            </Typography>
                                            <Typography sx={{ color:'#000', textAlign:'left' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                <b>Interest/anum: {input.interest_percentage_rate_anum}% </b> 
                                            </Typography> 

                                            <Accordion 
                                                sx={{ borderRadius:2, mb:2 }}
                                            >
                                                <AccordionSummary
                                                    expandIcon={<ExpandMore />}
                                                    aria-controls="panel2a-content"
                                                    id="panel3a-header"
                                                    display='flex'
                                                >
                                                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"><b>Private interest?</b></Typography>
                                                </AccordionSummary>
                                                <AccordionDetails>
                                                    <FormControl>
                                                        <FormLabel id="demo-row-radio-buttons-group-label">Type</FormLabel>
                                                        <RadioGroup
                                                            row
                                                            aria-labelledby="demo-row-radio-buttons-group-label"
                                                            name='interest_type'
                                                            value={subscribed_i.find(item => item.product_id === input.product_id)?.interest_type || ''}
                                                            onChange={(e) => {
                                                                const value = e.target.value;
                                                                const updatedSubscribed_i = subscribed_i.map(item => {
                                                                    if (item.product_id === input.product_id) {
                                                                        return {
                                                                            ...item,
                                                                            interest_type: value
                                                                        };
                                                                    }
                                                                    return item;
                                                                });
                                                                setSubscribed_i(updatedSubscribed_i);
                                                            }}
                                                        >
                                                            <FormControlLabel value="flat_rate" control={<Radio />} label="Fixed Amount" />
                                                            <FormControlLabel value="percentage_rate" control={<Radio />} label="Percentage Rate" />
                                                            <FormControlLabel value="" control={<Radio />} label="Default" />
                                                        </RadioGroup>
                                                    </FormControl>
                                                    {
                                                        subscribed_i.find(item => item.product_id === input.product_id)?.interest_type === 'flat_rate'?(
                                                            <TextField
                                                                size='small'
                                                                type='number'
                                                                variant='standard'
                                                                label='Type here'
                                                                inputProps={{ step: 'any' }}
                                                                name='private_interest'
                                                                value={subscribed_i.find(item => item.product_id === input.product_id)?.private_interest || null}
                                                                onChange={(e) => {
                                                                    const value = e.target.value;
                                                                    const updatedSubscribed_i = subscribed_i.map(item => {
                                                                        if (item.product_id === input.product_id) {
                                                                            return {
                                                                                ...item,
                                                                                private_interest: value
                                                                            };
                                                                        }
                                                                        return item;
                                                                    });
                                                                    setSubscribed_i(updatedSubscribed_i);
                                                                }}
                                                            />
                                                        ): subscribed_i.find(item => item.product_id === input.product_id)?.interest_type === 'percentage_rate'?(
                                                            <>
                                                                <TextField
                                                                    size='small'
                                                                    type='number'
                                                                    variant='standard'
                                                                    label='Type here (%)'
                                                                    inputProps={{ step: 'any' }}
                                                                    name='private_interest'
                                                                    value={subscribed_i.find(item => item.product_id === input.product_id)?.private_interest || null}
                                                                    onChange={(e) => {
                                                                        const value = e.target.value;
                                                                        const updatedSubscribed_i = subscribed_i.map(item => {
                                                                            if (item.product_id === input.product_id) {
                                                                                return {
                                                                                    ...item,
                                                                                    private_interest: value
                                                                                };
                                                                            }
                                                                            return item;
                                                                        });
                                                                        setSubscribed_i(updatedSubscribed_i);
                                                                    }}
                                                                />
                                                                <TextField
                                                                    size='small'
                                                                    type='number'
                                                                    variant='standard'
                                                                    label='number of months'
                                                                    name='interest_months'
                                                                    value={subscribed_i.find(item => item.product_id === input.product_id)?.interest_months || null}
                                                                    onChange={(e) => {
                                                                        const value = e.target.value;
                                                                        const updatedSubscribed_i = subscribed_i.map(item => {
                                                                            if (item.product_id === input.product_id) {
                                                                                return {
                                                                                    ...item,
                                                                                    interest_months: value
                                                                                };
                                                                            }
                                                                            return item;
                                                                        });
                                                                        setSubscribed_i(updatedSubscribed_i);
                                                                    }}
                                                                />
                                                                
                                                            </>
                                                        ):null
                                                    }
                                                </AccordionDetails>
                                            </Accordion>

                                            {/* <Button sx={{ m:1, backgroundColor:'#eb5e28', borderRadius:4 }} size="small"  variant="contained">
                                                Private interest
                                            </Button> */}
                                            <Button 
                                                sx={{ 
                                                    m:1, 
                                                    backgroundColor: subscribed_i.find(item => item.product_id === input.product_id)?.subscribe === true? '#bc6c25': '#eb5e28' , 
                                                    borderRadius:4 
                                                }} 
                                                size="small"  
                                                variant="contained"
                                                onClick={() => {
                                                    const updatedSubscribed_i = subscribed_i.map(one => {
                                                        if (one.product_id === input.product_id) {
                                                            return {
                                                                ...one,
                                                                subscribe: !one.subscribe
                                                            };
                                                        }
                                                        return one;
                                                    });
                                                    setSubscribed_i(updatedSubscribed_i);
                                                }}
                                            >
                                                {
                                                    subscribed_i.find(item => item.product_id === input.product_id)?.subscribe === true?
                                                    'Unsubscribe'
                                                    :
                                                    'Subscribe'
                                                }
                                                
                                            </Button>
                                            
                                        </ItemCardI>
                                    ))
                                }
                                </Box>
                                
                            </Grid>

                            

                        </Grid>
                        :
                        null
                    }
                </Grid>
            

                    {
                        service_subscribed[0] || input_subscribed[0]?
                            <Grid item xs={12} md={12}>
                                <Typography variant='h4' sx={{textAlign:'center'}} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                    <b>Complete Subscription</b>
                                </Typography>
                                <Typography variant='h6' sx={{textAlign:'center'}} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                    <b>Accumulated Cost: {currencyFormat.format(deep_details.accumulative_cost)}</b>
                                </Typography>
                                <Grid container spacing={1}>
                                    <Grid item xs={12} md={6}>
                                        <Typography variant='h5' sx={{ textAlign:'center' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                            <b>Subscribed Services</b> 
                                        </Typography>
                                        <Typography variant='h6' sx={{ textAlign:'center' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                            <b>Total service cost {currencyFormat.format(deep_details.service_cost)}</b> 
                                        </Typography>
                                        <div style={{ display:'flex', flexWrap:'wrap', maxHeight: 540, overflowY: 'auto', '&::-webkit-scrollbar': {
                                                    width: '7px',
                                                },
                                                '&::-webkit-scrollbar-track': {
                                                    background: '#f1f1f1',
                                                },
                                                '&::-webkit-scrollbar-thumb': {
                                                    background: '#888',
                                                    borderRadius: '10px',
                                                },
                                                '&::-webkit-scrollbar-thumb:hover': {
                                                    background: '#555',
                                            }}}>
                                            {
                                                service_subscribed.map((service) => (
                                                    <ItemCardSS>
                                                        <Typography sx={{ color:'#000', textAlign:'center' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                            <b>{service.service}</b> 
                                                        </Typography>
                                                        <Divider variant='middle' />
                                                        <Typography sx={{ color:'#000', textAlign:'left' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                            <b>Cost: {currencyFormat.format(service.cost)}</b> 
                                                        </Typography>
                                                        <Divider variant='middle' />
                                                        <Typography sx={{ color:'#000', textAlign:'left' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                            <b>Interest Type: {service.interest_type === 'flat_rate'? 'Fixed Amount': 'Percentage rate'}</b> 
                                                        </Typography>
                                                        <Divider variant='middle' />
                                                        <Typography sx={{ color:'#000', textAlign:'left' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                            <b>Interest Amount: {currencyFormat.format(service.interest)}</b> 
                                                        </Typography>
                                                        {
                                                            service.interest_type === 'percentage_rate'?
                                                            <>
                                                            <Divider variant='middle' />
                                                            <Typography sx={{ color:'#000', textAlign:'left' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                                <b>Number of months: {service.months}</b> 
                                                            </Typography>
                                                            </>:
                                                            null
                                                        }
                                                        <Divider variant='middle' />
                                                        <Typography sx={{ color:'#000', textAlign:'left' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                            <b>Total Cost: {currencyFormat.format(service.total_cost)} </b> 
                                                        </Typography>
                                                    </ItemCardSS>
                                                ))
                                                
                                            }
                                        </div>
                                    </Grid>

                                    <Grid item xs={12} md={6}>
                                        <Typography variant='h5' sx={{ textAlign:'center' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                            <b>Subscribed Inputs</b> 
                                        </Typography>
                                        <Typography variant='h6' sx={{ textAlign:'center' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                            <b>Total inputs cost {currencyFormat.format(deep_details.input_cost)}</b> 
                                        </Typography>
                                        <div style={{ display:'flex', flexWrap:'wrap', maxHeight: 540, overflowY: 'auto', '&::-webkit-scrollbar': {
                                                    width: '7px',
                                                },
                                                '&::-webkit-scrollbar-track': {
                                                    background: '#f1f1f1',
                                                },
                                                '&::-webkit-scrollbar-thumb': {
                                                    background: '#888',
                                                    borderRadius: '10px',
                                                },
                                                '&::-webkit-scrollbar-thumb:hover': {
                                                    background: '#555',
                                            }}}>
                                        {
                                                input_subscribed.map((input) => (
                                                    <ItemCardSI>
                                                        <Typography sx={{ color:'#000', textAlign:'center' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                            <b>{input.input}</b> 
                                                        </Typography>
                                                        <Divider variant='middle' />
                                                        <Typography sx={{ color:'#000', textAlign:'left' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                            <b>Company: {input.company}</b> 
                                                        </Typography>
                                                        <Divider variant='middle' />
                                                        <Typography sx={{ color:'#000', textAlign:'left' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                            <b>Quantity needed: {input.quantity_needed}</b> 
                                                        </Typography>
                                                        <Divider variant='middle' />
                                                        <Typography sx={{ color:'#000', textAlign:'left' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                            <b>Cost: {currencyFormat.format(input.cost)}</b> 
                                                        </Typography>
                                                        <Divider variant='middle' />
                                                        <Typography sx={{ color:'#000', textAlign:'left' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                            <b>Interest Type: {input.interest_type === 'flat_rate'? 'Fixed Amount': 'Percentage rate'}</b> 
                                                        </Typography>
                                                        {
                                                            input.interest_type === 'percentage_rate'?
                                                            <>
                                                            <Divider variant='middle' />
                                                            <Typography sx={{ color:'#000', textAlign:'left' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                                <b>Number of months: {input.months}</b> 
                                                            </Typography>
                                                            </>:
                                                            null
                                                        }
                                                        <Divider variant='middle' />
                                                        <Typography sx={{ color:'#000', textAlign:'left' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                            <b>Interest Amount: {currencyFormat.format(input.interest)}</b> 
                                                        </Typography>
                                                        <Divider variant='middle' />
                                                        <Typography sx={{ color:'#000', textAlign:'left' }} fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                                            <b>Total Cost: {currencyFormat.format(input.total_cost)} </b> 
                                                        </Typography>
                                                    </ItemCardSI>
                                                ))
                                                
                                            }
                                        </div>
                                    </Grid>
                                </Grid>
                                
                            </Grid>
                        :
                        null
                    }
                    

                    {
                        hold_crop?
                        <Grid item xs={12} md={6}>
                            <Button 
                                size='small' 
                                sx={{ 
                                    m:1, 
                                    borderRadius:4,
                                    backgroundColor:'#eb5e28',
                                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)',
                                    minWidth: 0,
                                    '&:hover': {
                                        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)',
                                        backgroundColor:'#bc6c25',
                                    },
                                }} 
                                variant='contained' 
                                onClick={handleSummarize}
                            >
                                {
                                    service_subscribed[0] || input_subscribed[0]?
                                    'Refresh'
                                    :
                                    'Summarize'
                                }
                                
                            </Button>
                            {
                                service_subscribed[0] || input_subscribed[0]?
                                <Button 
                                    size='small' 
                                    sx={{ 
                                        m:1, 
                                        borderRadius:4,
                                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)',
                                        minWidth: 0,
                                        '&:hover': {
                                            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)',
                                        },
                                    }} 
                                    variant='contained' 
                                    color='success' 
                                    onClick={handleConfirmLoan}
                            >
                                Confirm loan 
                            </Button>
                                : null
                            }
                            
                        </Grid>
                        :
                        null
                    }
            
          </Grid>
        </Box>
      </Modal>
      {/* another modal */}
        {name_modal}
      {/* another modal ends */}

      <Modal
        open={upload_open}
        onClose={closeGroupUploads}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      > 
        <Box sx={style}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={12}>
                <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" textAlign='center' variant='h4'><b>Group Loan Docs</b></Typography>
              </Grid>

              <Grid item xs={12} md={12}>
                  <Button 
                    size='small' 
                    sx={{ 
                        m:1, 
                        borderRadius:4,
                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1), 0 6px 20px rgba(0, 0, 0, 0.1)',
                        minWidth: 0,
                        '&:hover': {
                            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)',
                        },
                    }} 
                    variant='contained' 
                    color='success'
                    onClick={handleButtonClickAct}
                    >
                      Upload scaned document
                    </Button>
                    <input
                      name="doc"
                      id="doc"
                      type="file"
                      accept="image/*"
                      style={{ display: 'none' }}
                      onChange={handleFileChange}
                    />
                 </Grid>
                 <Grid item xs={12} md={12}>
                  {
                      image?
                      <div style={{ display:'flex', flexDirection:'row' }}>
                        <Avatar sx={{ height: 150, width: 150 }} alt={fileName} src={image}/>
                        <IconButton 
                          onClick={() => {
                              setFileName("No selected File");
                              setImage(null);
                              formik_upload.setFieldValue("doc", null);
                          }}>
                            <CancelIcon color='error'/>
                        </IconButton>
                        <IconButton onClick={formik_upload.handleSubmit}>
                          <CheckCircleIcon color='success' />
                        </IconButton>
                      </div>
                      :
                      null
                    }
                 </Grid>
                 <Grid item xs={12} md={12}>
                 <Divider sx={{ m:2 }}/>
                  <Box 
                    sx={{ 
                      display:'flex',
                      flexWrap:'wrap',
                      maxHeight: "70vh", 
                      overflow:'auto',
                      '&::-webkit-scrollbar': {
                        width: '5px',
                        height: '4px'
                      },
                      '&::-webkit-scrollbar-track': {
                          background: '#f1f1f1',
                      },
                      '&::-webkit-scrollbar-thumb': {
                          background: '#888',
                          borderRadius: '10px',
                      },
                      '&::-webkit-scrollbar-thumb:hover': {
                          background: '#555',
                      } 
                    }}
                    >
                    {
                      group_documents[0]?
                      group_documents.map((doc) => (
                        <div style={{ display:'block', margin:'7px' }}>
                          <Tooltip>
                            <IconButton 
                              onClick={() => del_doc(doc.doc_id)}>
                              <CancelIcon color='error'/>
                            </IconButton>
                          </Tooltip>
                          <Avatar onClick={() => handleOpenImageModal(pic(doc.doc_image))} sx={{ height: 170, width: 170, cursor: 'pointer' }} alt='Signed Document' src={pic(doc.doc_image)}/>
                        </div>
                      ))
                      :
                      <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" textAlign='center' variant='h4'><b>No Docs</b></Typography>
                    }
                  </Box>
                 </Grid>
              </Grid>
        </Box>
      </Modal>

      {selectedImage && (
        <Modal
          open={openImageModal}
          onClose={handleCloseImageModal}
          aria-labelledby="image-modal-title"
          aria-describedby="image-modal-description"
        >
          <Box
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              width: '80%',
              boxShadow: 24,
              p: 4,
              maxHeight: "90vh", 
              overflowY:'auto',
              '&::-webkit-scrollbar': {
                width: '5px',
                height: '4px'
              },
              '&::-webkit-scrollbar-track': {
                  background: '#f1f1f1',
              },
              '&::-webkit-scrollbar-thumb': {
                  background: '#888',
                  borderRadius: '10px',
              },
              '&::-webkit-scrollbar-thumb:hover': {
                  background: '#555',
              } 
            }}
          >
            <img src={selectedImage} alt="Selected" style={{ width: '100%', height: 'auto' }} />
          </Box>
        </Modal>
      )}
    </div>
  )
}

export default AssociationDisbursedLoans